import common from './common';
import LocalizationKeys from './interface';

const pl: LocalizationKeys = {
	...common,

	offer: 'Oferta',
	// payment
	paymentTab1: 'Wpłaty',
	paymentTab2: 'Wypłaty',
	paymentTab1Title: 'SZYBKIE PRZELEWY W BETFAN',
	paymentTab2Title: 'WYPŁATY',
	paymentTab1Description:
		'Graczu oferujemy Ci dogodne płatności jakich możesz dokonać na naszej stronie. Możesz to uczynić na różne sposoby za pomocą Blika, Przelewów24 lub za pomocą karty. Przy żadnej z transakcji nie pobieramy prowizji. Są one dostępne całą dobę, a minimalna wpłata depozytu jaką przyjmujemy to 2 zł',
	paymentTab2Description:
		'Mamy szybkie wpłaty, ale również mamy szybkie wypłaty! Siano z Twojego konta jest wypłacane na Twoje zlecenie i trwa to średnio do 15 minut. Bezpieczne wypłaty są realizowane 7 dni w tygodniu (od 8:00 do 00:00) do ponad 97% kont bankowych w Polsce',
	paymentInfo1: 'PŁATNOŚĆ <br /> BLIK',
	paymentInfo2: 'PRZELEW <br /> BANKOWY',
	paymentInfo3: 'PŁATNOŚĆ <br /> KARTĄ',
	paymentInfo4: 'PAYSAFE <br /> CARD',
	guarantee: 'GWARANCJA',
	implementation: 'REALIZACJA',
	average: 'ŚREDNIO',
	guaranteeDescription: 'W 100% bezpieczne wypłaty środków',
	implementationDescription: 'wypłaty środków 7 dni w tygodniu (od 8:00 do 00:00)',
	averageDescription: 'co 15 minut realizowane są wypłaty środków naszych klientów',
	bankList: 'LISTA BANKÓW',
	paymentFooter: 'Płatności',
	PaymentsText: 'Pełna lista banków wraz z godzinami, w których zlecane są szybkie wypłaty',
	p24RegulationsText: 'Płacąc oświadczam, że zapoznałem się z regulaminem i obowiązkiem informacyjnym serwisu Przelewy24',
	enterBlikManually: 'Chcę wpisać ręcznie kod',

	// contact
	contactHeadline: 'Jeśli potrzebujesz pomocy napisz do nas',
	contactCompanyName: 'BETFAN Sp. z o.o.',
	contactCompanyNip: 'NIP 525 274 71 32',
	contactCompanyAddress: 'Ul. Prosta 68',
	contactCompanyPostcode: '00-838 Warszawa',
	contactChatHeadline: 'Jesteśmy dostępni dla Ciebie codziennie w godzinach 8-23',
	contactChatText: 'Czat',
	contactEmailHeadline: 'Email',
	contactEmailText: 'bog@betfan.pl',
	contactVipEmailText: 'vip@betfan.pl',
	contactFormHeadline: 'Formularze',
	contactFormText: 'Formularz reklamacyjny',
	contactMarketingHeadline: 'Marketing',
	contactMarketingText: 'marketing@betfan.pl',

	modalPendingTitle: 'Wpłata w toku',
	modalPendingButton: 'Rozumiem',
	modalPendingDescription: 'Potwierdź płatność w aplikacji banku.',

	modalPaymentProceedTitle: 'Wpłata w toku',
	modalPaymentProceedButton: 'Rozumiem',
	modalPaymentProceedDescription: 'Twoje saldo zostanie zasilone wkrótce.',

	modalGenericErrorDescription: 'Skorzystaj z innej metody płatności lub spróbuj ponownie później.',
	modalGenericErrorTitle: 'Coś jest nie tak',

	// aboutUs
	aboutUs: 'O Nas',
	aboutUsTitle1: 'BETFAN to legalny polski bukmacher',
	aboutUsBetDescription1: 'Powstaliśmy, aby każdego dnia dostarczać niepowtarzalną i unikatową porcję rozrywki',
	aboutUsBetDescription2: 'U nas nie tylko gracie, ale przede wszystkim dobrze się bawicie',
	aboutUsBetDescription3:
		'SPORT, LIVE, ESPORT i ROZRYWKA to kategorie naszych produktów, które oddajemy Wam do dyspozycji. Liczymy, że ponad 1 500 000 zakładów miesięcznie zaspokoi potrzeby nawet najbardziej wymagających graczy. A do tego dochodzą jeszcze nasze własne, niespotykane nigdzie indziej zakłady!',
	aboutUsTitle2: 'CHCEMY BYĆ JAK KUMPEL',
	aboutUsBetDescription4:
		'Chcemy być jak kumpel! Postaramy się być zabawni, nowocześni i mocno lifestylowi, damy Wam również motywację do wejścia do naszego świata w postaci atrakcyjnych bonusów i promocji',
	aboutUsBetDescription5:
		'Będziemy wychodzić poza przyjęte schematy, dostosowywać przekaz komunikacji pod Wasze preferencje, bo dla nas to Wy – nasi Gracze i Fani jesteście największym i najcenniejszym dobrem',
	aboutUsBetDescription6:
		'Oczywiście, a może przede wszystkim potrafimy być poważni i profesjonalni, o czym stanowi ustanowiony i do dziś niepobity rekord Polski w szybkości uzyskania licencji bukmacherskiej online – urzędowe 6 miesięcy, co do dnia!',
	note: 'Pamiętaj: <strong>NIE GRASZ, NIE WYGRASZ!</strong>',
	emailContact: 'Kontakt mailowy',
	certificateInfo:
		'Pracownicy BETFAN są przeszkolenii w zakresie Odpowiedzialnej GRY - <a class="text--midnight-green font--bold" href="https://www.betfan.pl/static/images/cms/MediaCenter/pdf/certyfikat-odpowiedzialnej-gry-betfan.pdf" target="_blank">Certyfikat</a>',

	//mybet
	myForm: 'My Form',
	fillData: 'UZUPEŁNIJ DANE:',
	makeBet: 'STWÓRZ ZAKŁAD',
	myBetDescription1: 'Chciałbyś się o coś założyć, ale nie masz wokół siebie chętnych na zawarcie zakładu?',
	myBetDescription2:
		'Już dziś możesz się założyć z nami o co chcesz! Myślisz, że podczas finału Ligi Mistrzów któryś z kibiców wybiegnie na boisko, a nie możesz nigdzie znaleźć oferty na to zdarzenie? <b>My wystawimy taki zakład!</b>',
	myBetDescription3:
		'Nasi bukmacherzy to specjaliści nie tylko od wydarzeń sportowych i okołosportowych, gdyż znają się również na szeroko pojętej rozrywce. Zresztą, zerknij na nasz dział „Rozrywka”! Może tam znajdziesz jakąś inspirację na stworzenie nietypowego zakładu? <b>Pamiętaj, że zakładamy się o prawie wszystko</b>',
	betSettlementDate: 'Proponowana data rozliczenia zakładu',
	settlementDate: 'Data rozliczenia',
	myBetDescription4:
		'Twoja propozycja zakładu będzie rozpatrzona przez naszych analityków w ciągu najbliższych 24 godzin. Po jej pozytywnej weryfikacji wyślemy do Ciebie maila z informacją zwrotną oraz wystawimy ofertę, która będzie <b>dostępna dla wszystkich naszych Graczy!</b>',
	myBetDescription5: 'Nie grasz, nie wygrasz!',
	contentCounter: 'Zostało <b>280</b>/280 znaków',
	myBetOptionalField: 'Pole nieobowiązkowe',
	emailAddress: 'Adres email',
	contentOfBet: 'Treść zakładu',
	iAccept: 'Akceptuję',
	iAccept2: 'regulamin usługi MyBET',
	reportAccepted: 'Twoje zgłoszenie zostało przyjęte do rozpatrzenia przez nasz dział analityków. Dziękujemy!',
	activeBonus: 'Bonus aktywny',
	freebets: 'Freebety',
	freebet: 'Freebet',
	pendingBonus: 'Bonus oczekujący',
	activeBonusDesc:
		'W tej sekcji znajdziesz bonus, który obecnie jest aktywny. Jego termin ważności już rozpoczął bieg, a do daty widocznej na kafelku musisz go w całości wykorzystać zgodnie ze szczegółowymi warunkami danego bonusu. Po kliknięciu w dany bonus znajdziesz zasady jego wykorzystania.',
	freebetDesc:
		'W tej sekcji znajdziesz wszystkie freebety, które Ci przysługują. Aby zagrać za freebet, należy utworzyć kupon i wybrać w podglądzie kuponu przycisk na niebieskim kafelku z nazwą danego freebetu. Pamiętaj, że od wygranej za freebet odejmowana jest jego stawka.',
	pendingBonusDesc:
		'Możesz posiadać tylko jeden aktywny bonus. Jeżeli w momencie posiadania aktywnego bonusu otrzymasz inny bonus, trafi on do kolejki oczekujących. Możesz go anulować lub aktywować. Aktywacja bonusu z kolejki oczekujących jest możliwa dopiero w momencie, gdy wykorzystasz aktywny bonus.',
	akoBooster: 'AKO Booster',
	contains: 'Zawiera',
	myBetOverlayMsg:
		'Siatkarze z Bhutanu grają z Brunei w towarzyskim spotkaniu do lat 17 i nie ma tego w ofercie BETFAN? Zaloguj się i napisz do nas, a my dodamy do oferty proponowany przez Ciebie zakład!',

	myBetFaqQuestion1: 'W jakim czasie przed rozpoczęciem wydarzenia należy wysłać prośbę o rozpatrzenie MyBet?',
	myBetFaqAnswer1: 'Minimum 4h przed rozpoczęciem zdarzenia.',

	myBetFaqQuestion2: 'Ile zgłoszeń mogę wysłać jednego dnia?',
	myBetFaqAnswer2: 'Maksymalna dzienna liczba zgłoszeń od jednego gracza to 3.',

	myBetFaqQuestion3: 'Czy dodane zdarzenie będzie dostępne tylko dla mnie?',
	myBetFaqAnswer3: 'Nie, z Twojego pomysłu na zakład będą mogli skorzystać także inni gracze. To Ty kreujesz ofertę dostępną dla wszystkich!',

	myBetFaqQuestion4: 'W jakim czasie otrzymam odpowiedź na zgłoszenie?',
	myBetFaqAnswer4:
		'Na zgłoszenia odpowiadamy najszybciej jak to możliwe. Czas odpowiedzi jest zależny od wielu czynników, m.in. od popularności rozgrywek, czy stopnia złożoności prośby.',

	myBetFaqQuestion5: 'Czy każde zgłoszenie zostanie uwzględnione?',
	myBetFaqAnswer5:
		'Staramy się uwzględniać jak najwięcej zgłoszeń, jednak nie każdy zakład może zostać wprowadzony do oferty. Odrzucone zostaną np. zgłoszenia dotyczące zdarzeń, na które nie da się oszacować kursu, czy też takie w których kurs na MyBet byłby zbyt niski.',
	myBetFaqQuestion6: 'Czy zostanę poinformowany o odpowiedzi na moje zgłoszenie?',
	myBetFaqAnswer6:
		'Tak jest o ile… posiadasz zarejestrowane konto Gracza! Wysyłamy drogą mailową potwierdzenie otrzymania zgłoszenia i tą drogą informujemy także o odpowiedzi.',

	// sideNav
	search: 'Wpisz szukaną fraze...',
	live: 'Live',
	sport: 'Sport',
	eSport: 'Esport',
	virtualSports: 'Sporty Wirtualne',
	cardGames: 'Gry karciane',
	entertainment: 'Rozrywka',
	promotion: 'Promocje',
	contact: 'Kontakt',
	language: 'Język',
	noteTitle: 'to legainy polski bukmacher.',
	noteSubTitle: 'Hazard wiąże się z ryzykiem.<1></1>Gra u nielicencjonowanych podmiotów jest niezgodna z prawem.',
	noSearchResults: 'Nic nie znaleźliśmy.',
	noSearchResultTextTwo: 'Nie kombinuj i nie wpisuj już tego Mynsienblablabla. Wpisz po prostu Borussia...',
	searchEventInfo: 'Wyszukaj mecz lub drużynę',

	// bottomNav
	home: 'Home',
	chat: 'Czat',
	coupon: 'Kupon',
	coupons: 'Kupony',
	virtuals: 'Wirtualne',
	siteMap: 'mapa-strony',
	cardGamesBottomMenu: 'Karty',
	cookieSettings: 'Ustawienia plików cookie',

	// home
	popularBets: 'Polecane zakłady sportowe',
	cookiePolicyPopupText: `
			Nasza strona korzysta z plików cookies. Więcej informacji znajdziesz <1>tutaj</1>
	`,

	// customerPanel
	mainBalance: 'Depozyt',
	bonusBalance: 'Bonus',
	bonusShortened: 'Bonus',
	accountVerificationPrompt: 'Konto tymczasowe!',
	accountVerificationPromptSubTitle: 'Zaktualizuj dane, aby kontynuować grę.',
	accountExpired: 'Twoje dokumenty wygasły!',
	payout: 'Wpłać',
	deposit: 'Wypłać',
	depositShortened: 'Depozyt',
	accountSettingsLabel: 'Konto',
	accountSettingsBonus: 'Bonusy',
	accountSettingsPromotionCode: 'Kody promocyjne',
	accountSettingsMessages: 'Wiadomości',
	generalSettingsLabel: 'Ustawienia',
	generalSettingsPersonalData: 'Dane osobowe',
	changeYourDetails: 'Zmiana danych',
	generalSettingsConsents: 'Zgody marketingowe',
	generalSettingsPolicy: 'Odpowiedzialna gra',
	logout: 'Wyloguj',
	currentSession: 'czas trwania sesji',
	passwordDoesNotMatch: 'Stare hasło jest nieprawidłowe',
	becomeVip: 'Zostań VIP',
	vipRank: 'Ranga VIP',
	vipUserMenu: 'Program Concierge',
	chatVip: 'Czat VIP',
	unlockBonus: 'Odblokowanie bonusu',
	bonusTransfer: 'Przeniesienie bonusu',
	usingFreebet: 'Wykorzystanie freebetu',
	pendingBonuses: 'Bonusy oczekujące',
	removeMessages: 'Skasować wybrane wiadomości?',
	removeAllMessages: 'Skasować wszystkie wiadomości?',
	selectMessages: 'Zaznacz wiadomości',
	removeAll: 'Usuń wszystkie',
	emptyInboxInfo: 'Aktualnie nie ma żadnych wiadomości',
	oneMessageInfo: 'wiadomość',
	moreMessagesInfo: 'wiadomości',
	messageHeaderInfo_zero: 'Wiadomości',
	messageHeaderInfo_one: '{{count}} wiadomość',
	messageHeaderInfo: '{{count}} wiadomości',
	welcomeMessages: 'Wiadomość powitalna',
	welcomeOffer: 'Oferta powitalna',
	welcomeOfferInfo:
		'Wpłać min. 50zł i graj za 3x więcej dzięki bonusowi 200%. Zgarnij nawet 400 zł bonusu (maksymalna wartość bonusu przy wpłacie 200 zł i więcej)',
	playerProfile: 'Profil Gracza',
	myAccount: 'Moje konto',
	prefrences: 'Preferencje',
	rulesBetSettlement: 'Zasady rozliczania zakładów',
	cpChat: 'Kontakt z Biurem Obsługi Gracza',
	verifyAccountAfterRegTitle: 'Twoje konto zostanie ograniczone za {{numofdays}} dni',
	verifyAccountAfterRegDesc: 'Zweryfikuj swoje konto, aby kontynuować grę.',
	verifyAccountThirtyDaysAfterReg: 'Twoje konto zostało ograniczone. Zweryfikuj swoje konto, aby wrócić do gry',

	// login
	login: 'Zaloguj się na konto',
	signIn: 'Zaloguj się',
	sessionExpiredMessage: 'Twoja sesja wygasła. Zaloguj się ponownie, aby kontynuować.',
	selfExclusionMessage: 'Twoje konto jest zablokowane. Możesz spróbować ponownie po:',
	wrongPasswordMessage: 'Błędny login lub hasło.',
	accountBlockedByCustomer: 'Konto zablokowane przez użytkownika. Skontaktuj się z BOG, aby odblokować konto',
	dailyLoginTimeExceeded: 'Przekroczono dzienny limit czasu bycia zalogowanym',
	monthlyLoginTimeExceeded: 'Przekroczono miesięczny limit czasu bycia zalogowanym',
	customerAccountNotActivated: 'Konto NIEAKTYWNE. Prosimy o potwierdzenie aktywności konta w wysłanym mailu aktywacyjnym.',
	accountBlockedByAdmin: 'Konto zablokowane. Spróbuj ponownie lub skontaktuj się z Biurem Obsługi Gracza',
	nextTimeUseBiometricLogin: 'Następnym razem użyj logowania biometrycznego',

	// registration
	signUp: 'Załóż konto',
	newEmail: 'Adres e-mail',
	enterYourEmail: 'Wpisz swój email',
	enterYourPassword: 'Wpisz swoje hasło',
	registration: 'Rejestracja',
	registrationText1: 'Jesteś nowym GRACZEM?',
	registrationText2: 'Załóż konto i odbierz przygotowany dla Ciebie Pakiet na START!',
	registrationAction: 'ZAŁÓŻ KONTO',
	registrationSubTitle: 'Szybka rejestracja w 30 sekund!',
	passwordConstraintText:
		'Hasło musi składać się z min. 8 znaków, posiadać wielką literę oraz min. 1 cyfrę. Nie może zawierać polskich liter np. ą, ę, ś',
	bonusConsent: 'Chcę otrzymać bonus powitalny Aby otrzymać bonus powitalny konieczne jest zaznaczenie obu zgód marketingowych',
	ageConsentTitle:
		'Zapoznałem się i akceptuję Regulamin Internetowch Zakładów Wzajemnych BETFAN, Regulamin Odpowiedzialnej Gry BETFAN, jak i poniższe oświadczenia.',
	ageConsentDescription: `Oświadczam, że: <br/> - Mam ukończone 18 lat <br/> - Podane przeze mnie dane osobowe są prawdziwe <br/> - Mój udział w zakładach wzajemnych nie narusza obowiązujących przepisów <br/> - <a>Rozumiem i akceptuję “Regulamin internetowych zakładów wzajemnych BETFAN” oraz “Regulamin odpowiedzialnej gry BETFAN”</a><br/> - Wyrażam zgodę na przetwarzanie przez BETFAN Sp. z o.o. moich danych osobowych w celu prowadzenia BETkonta oraz umożliwienia uczestnictwa w organizowanych zakładach wzajemnych. Administratorem danych jest BETFAN Sp. z o.o. z siedzibą w Warszawie. Podanie danych osobowych jest dobrowolne, jednak niezbędne w celu realizacji usług. <br/> - Rozumiem i akceptuję, że szczegółowe informacje związane z przetwarzaniem danych osobowych, w tym zakres przetwarzania oraz przysługujące mi prawa znajdują się w Polityce Prywatności i klauzuli informacyjnej RODO, zapoznałem się z jej treścią i akceptuję jej postanowienia.`,
	allConsents: 'Zaznacz zgody marketingowe, aby otrzymać bonus powitalny.',
	allConsentsDescription: `Wyrażam zgodę na przesyłanie przez BETFAN Sp. z o. o.: <br/>
- Informacji handlowych na podany adres e-mail na podstawie art. 10 ustawy o świadczeniu usług drogą elektroniczną. <br/>
- Telekomunikacyjnych urządzeń końcowych, a także automatycznych systemów wywołujących w celu marketingu bezpośredniego, w tym na wysyłanie wiadomości sms/mms oraz nawiązywanie połączeń głosowych. <br/>
Zgoda dot. w szczególności informacji o BONUSACH i PROMOCJACH oraz na przetwarzanie moich danych osobowych w powyższym zakresie. Szczegółowe informacje związane z przetwarzaniem danych osobowych, w tym zakres przetwarzania oraz przysługujące mi prawa znajdują się w <a>Polityce Prywatności</a> i <a2>klauzuli informacyjnej RODO<a2/>.`,
	emailConsent:
		'Wyrażam zgodę na przesyłanie przez BETFAN Sp z o.o. drogą <1>E-MAIL</1> informacji handlowych na podany adres na podstawie art.. 10 ustawy o świadczeniu usług drogą elektroniczną, w szczególności informacji o <3>BONUSACH i PROMOCJACH</3> oraz na przetwarzanie moich danych osobowych w powyższym zakresie. Szczegółowe informacje związane z przetwarzaniem danych osobowych, w tym zakres przetwarzania oraz przysługujące mi prawa znajdują się w <5>Polityce Prywatności i klauzuli informacyjnej RODO</5>.',
	smsConsent:
		'Wyrażam zgodę na wysyłanie przez BETFAN Sp. z o.o. wiadomości <1>SMS/MMS</1> na podany numer telefonu a także telekomunikacyjnych urządzeń końcowych, automatycznych systemów wywołujących w celu marketingu bezpośredniego, w tym na wysyłanie wiadomości sms/mms oraz nawiązywanie połączeń głosowych, w szczególności zawierających informacje o <3>BONUSACH i PROMOCJACH</3> oraz na przetwarzanie moich danych osobowych w powyższym zakresie. Szczegółowe informacje związane z przetwarzaniem danych osobowych, w tym zakres przetwarzania oraz przysługujące mi prawa znajdują się w <5>Polityce Prywatności i klauzuli informacyjnej RODO</5>.',
	selectCountryText: 'Wybierz narodowość z poniższej listy:',
	registrationSuccess: 'Konto utworzone',
	registrationSuccessInfo: 'Sprawdź swoją skrzynkę mailową i postępuj zgodnie z kolejnymi krokami.',
	hashtag: 'niegraszniewygrasz',
	smsCodeSent: 'Wysłano kod sms.',
	peselValidationText: 'Dozwolone są tylko wartości liczbowe i muszą mieć 11 cyfr digits',
	peselValueValidation: 'Niepoprawny numer PESEL',
	peselAgeValidationText: 'Użytkownik musi mieć ukończone 18 lat',
	smsCodeValidationText: 'Kod SMS musi składać się z 4 cyfr',
	smsCodeInvalidText: 'Nieprawidłowy kod SMS. Sprawdź i spróbuj ponownie.',
	registrationLastNameTooShort: 'Wprowadzone nazwisko jest za krótkie (min. 2 litery).',
	registrationPasswordIllegalCharacters: 'Hasło zawiera niedozwolone znaki. Popraw je i spróbuj ponownie.',
	registrationDescription1: 'Wysłaliśmy e-mail weryfikacyjny',
	registrationDescription2:
		'Kliknij w link wysłany na adres {{emailId}}, aby aktywować konto. Jeśli nie otrzymałeś/aś wiadomości z linkiem weryfikacyjnym. sprawdź folder SPAM',
	registrationFinishButtonText: 'Przejdź do logowania',
	regStep1Heading: '👋 Siemka, jak się do Ciebie zwracać?',
	regStep2Heading: '👤 Super, teraz pora na nazwisko.',
	regStep3Heading: `📩 Czas na Twój adres <br/> e-mail!`,
	regStep4Heading: '🔐 Zabezpiecz konto hasłem',
	regStep5Heading: '🔢 Podaj swój numer PESEL',
	regStep6Heading: '📲 Wpisz swój numer telefonu',
	regStep7Heading: '💬 Wpisz czterocyfrowy kod',
	regStep8Heading: '🎁 Prezent? Podaj kod promocyjny!',
	regStep9Heading: '📝 Zgody – ostatnia formalność',
	regStep1SubHeading: 'Podaj swoje imię zgodne z dowodem tożsamości.',
	regStep2SubHeading: 'Tylko nie wymyślaj 😉. Też musi być zgodne z dowodem.',
	regStep3SubHeading: 'To będzie twój login! Obiecujemy, że nie będziemy spamować!',
	regStep4SubHeading: 'Zapamiętaj hasło lub korzystaj z logowania biometrycznego',
	regStep5SubHeading: 'Chcemy się upewnić, że jesteś pełnoletnim Graczem.',
	regStep6SubHeading: 'Wyślemy Ci na niego kod aktywacyjny SMS-em.',
	regStep6SubHeadingAlt: 'Wpisz numer, a konto aktywuj, klikając w link w mailu.',
	regStep7SubHeading: 'Kod podaj poniżej. Jeśli nadal nie dotarł, poproś o ponowne wysłanie.',
	regStep8SubHeading: 'Wpisz go poniżej, zdrap swój kod lub po prostu przejdź dalej.',
	regStep8SubHeadingAlt: 'Wpisz go lub po prostu przejdź dalej, jeśli jest już podany.',
	regStep9SubHeading: 'Zaznacz wszystkie zgody i bądź na bieżąco.',
	finish: 'Zakończ',
	selectEverything: 'Zaznacz wszystkie zgody. Niech nic Cię nie ominie!',
	selectConsentsInfo: 'Może warto zaznaczyć zgody?',
	selectConsentsDescription: 'Hej! Przegapisz wszelkie bonusy, jeśli nie zaakceptujesz zgód marketingowych',
	skip: 'Pomiń',
	tickConsent: 'Zaznacz zgody',
	nextTime: 'Innym razem',
	registrationFinishByEmailToastText: 'To jeszcze nie wszystko. Wejdź na swój e-mail. Aktywuj konto, klikając w link i ciesz się grą!',
	registrationFinishToastTextActive: 'To już wszystko! Twoje konto jest aktywne. Wpłać depozyt i ciesz się grą!',

	quit: 'Wróć',
	regErrorMessage: 'Wystąpił błąd, spróbuj ponownie.',
	emailDomainWarning: 'Wykryliśmy nietypowy adres e-mail. Sprawdź czy jest poprawny',
	emailActivationLabel: 'Chcę aktywować konto poprzez e-mail',

	// forgotPassword
	forgotPassword: 'Zapomniałeś hasła?',
	changePassword: 'Zmiana hasła',
	changePasswordMessage: 'Zmienić hasło?',
	resetConfirmation: 'Czy na pewno chcesz zmienić swoje hasło?',
	resetLinkSent: 'Link wysłany',
	resetLinkSentInfo: 'Niedługo otrzymasz od nas e-mail z instrukcją zmiany hasła.',
	changePasswordSuccess: 'Hasło pomyślnie zmienione',
	changePasswordSuccessInfo: 'Możesz zalogować się za pomocą nowego hasła.',
	forgotPassHelperText: 'Wpisz adres e-mail podany podczas rejestracji konta',
	invalidEmailInput: 'Podane dane są nieprawidłowe',

	//input placeholders
	placeholderCouponName: 'Nazwa kuponu',
	placeholderChooseFromList: 'Wybierz z listy',
	placeholderName: 'Donald',
	placeholderSecondName: 'Kowalski',
	placeholderPesel: '01029511222',
	placeholderPhone: '666555444',
	placeholderSmsCode: '1234',
	placeholderDate: 'DD/MM/YYYY',
	placeholderCountry: 'Wybierz kraj z listy',
	placeholderStreet: 'Kwiatowa',
	placeholderCity: 'Warszawa',
	placeholderBuildingNumber: '16',
	placeholderApartmentNumber: '21',
	placeholderZipCode: '01-477',
	placeholderSeriesNumber: 'np. AGG541344',
	placeholderBankAccountNumber: '49 1020 2892 2276 3005 0000 0000',
	placeholderSourceOfIncome: 'Wybierz źródło',
	placeholderChooseCountry: 'Wybierz kraj z listy',

	// validation
	genericRequiredFieldValidation: 'Pole wymagane',
	requiredFieldValidation: '{{field}}',
	notRequiredField: 'Pole nie jest wymagane',
	selectFieldValidation: 'proszę wybrać {{field}}',
	lowercaseFieldValidation: '{{field}} musi być ciągiem małych liter!',
	trimValidation: '{{field}} nie może zawierać spacji na początku / końcu!',
	minLengthFieldValidation: '{{field}} musi być dłuższy niż {{length}} postacie!',
	maxLengthFieldValidation: '{{field}} musi być krótszy niż {{length}} postacie!',
	minValueFieldValidation: '{{field}} musi być większa lub równa {{value}}!',
	maxValueFieldValidation: '{{field}} musi być mniejsze lub równe {{value}}!',
	passwordMatchValidation: 'Hasła nie pasują do siebie',
	typeValidation: 'Podaj prawidłowy {{type}}',
	validationError: 'Podane dane są nieprawidłowe',
	alreadyExistsValidation: '{{field}} już istnieje',
	invalidInput: 'Proszę wpisać poprawny {{field}}',
	generalSelectValidation: 'Wybierz jedną z powyższych opcji',
	passwordFormatText: 'Hasło musi mieć minimum 8 znaków.',
	emailFormatText: 'Dla m.in. xyz@example.com',
	phoneNumberFormatText: 'Numer telefonu jest za krótki. Musi mieć 9 cyfr.',
	seriesNumberFormatText: 'Dla m.in. XXX000000',
	postalCodeFormatText: 'Dla m.in. XX-XXX',
	bankAccountNumberWrong: 'Numer konta bankowego nieprawidłowy',
	bankAccountNumberFormatText: 'Powinno mieć dokładnie 26 cyfr.',
	bankAccountNumberRevolutAlert: 'Zmień numer konta. Ten bank nie daje możliwości wypłaty wygranych środków. ',
	bankAccountNumberBadChecksum: 'Nieprawidłowa suma kontrolna.',
	blikCodeFormatText: 'Kod BLIK jest za krótki. Musi mieć 6 cyfr.',
	cardNumberFormatText: 'Powinno mieć dokładnie 16 cyfr.',
	cvvCodeFormatText: 'Kod CVV jest za krótki. Musi mieć 3 cyfr.',
	shouldNotPastDate: "The date should not' be past date",
	tooShortSearchValueInfo: 'Wyszukiwana fraza powinna zawierać min. 3 znaki',
	documentIdValidation: 'Podany {{field}} istnieje w bazie',
	seriesNumberField: 'seria i numer',
	emailFieldValidation: 'Email nieprawidłowy',
	inValidPassword: 'Hasło nieprawidłowe',
	invalidPasswordConfirmation: 'Hasła różnią się od siebie',
	specifyCorrectPostalCode: 'Wpisz prawidłowy kod pocztowy.',
	specifyCorrectStreet: 'Wpisz prawidłową ulicę',
	couponNameValidation: 'Maks. liczba znaków: 40',

	// actions
	confirm: 'Potwierdź',
	cancel: 'Anuluj',
	return: 'Powrót',
	next: 'Następny',
	further: 'Dalej',
	send: 'Wysłij',
	back: 'Wstecz',
	submit: 'Zatwierdź',
	verify: 'Zweryfikuj',
	activate: 'Aktywuj',
	more: 'Więcej',
	backToHome: 'wrócić do domu',
	yes: 'Tak',
	no: 'Nie',
	ok: 'Ok',
	saveChanges: 'Zapisz zmiany',
	save: 'Zapisz',
	retry: 'Spróbuj ponownie',

	// dialog header
	success: 'Powodzenie',
	error: 'Błąd',
	congratulations: 'Gratulacje',
	thankyou: 'Dziękujemy',

	// form fields
	email: 'E-mail',
	password: 'Hasło',
	confirmPassword: 'Potwierdź hasło',
	oldPassword: 'Wprowadź stare hasło',
	newPassword: 'Nowe hasło',
	confirmNewPassword: 'Potwierdź nowe hasło',
	rememberMe: 'Zapamiętaj mnie',
	registrationCode: 'Kod rejestracyjny',
	firstName: 'Imię',
	lastName: 'Nazwisko',
	peselNum: 'Numer PESEL',
	peselNotAvailable: 'Nie mam numeru PESEL <br/>(tylko dla obcokrajowców)',
	dob: 'Data urodzenia',
	country: 'Kraj',
	phoneNum: 'Numer telefonu',
	phoneNum_invalid: 'Numer telefonu jest nieprawidłowy',

	smsCode: 'Kod sms',
	sendCodeAwait: 'Kod w trakcie wysyłki, proszę czekać...',
	sendCodeAgain: 'Wyślij ponownie kod',
	detailsAcknowledgement: `
		Oświadczam, że:
		<1></1>
		1) podane przeze mnie dane osobowe
		są prawdziwe,
		<3></3>
		2) mój udział w zakładach wzajemnych
		nie narusza obowiązujących przepisów,
		<5></5>
		3) zapoznałem się z treścią <7>Regulaminu</7>
		i akceptuję jego postanowienia.
		<9></9>
		4) wyrażam zgodę na przetwarzanie przez BETFAN Sp. z o.o. moich danych osobowych w celu prowadzenia BETkonta
		oraz umożliwienia uczestnictwa w organizowanych zakładach wzajemnych. Administratorem danych jest BETFAN Sp. z o.o.
		z siedzibą w Warszawie. Podanie danych osobowych jest dobrowolne, jednak niezbędne w celu realizacji usług.
		Rozumiem i akceptuję, że szczegółowe informacje związane z przetwarzaniem danych osobowych, w tym zakres
		przetwarzania oraz przysługujące mi prawa znajdują się w <11>Polityce Prywatności i klauzuli informacyjnej RODO</11>,
		zapoznałem się z jej treścią i akceptuję jej postanowienia.
	`,

	// misc
	showMore: 'Pokaż więcej',
	draw: 'Remis',
	and: 'i',
	step: 'Krok',
	of: 'z',
	or: 'lub',
	genericErrorMessage: 'Wystąpił błąd. Spróbuj ponownie później.',
	information: 'Informacje',
	oNas: 'Następnie jako',
	helpCenter: 'Centrum pomocy',
	whatsNewInApp: 'Co nowego w aplikacji?',
	designationOfStrucutre: 'Słownik Bukmacherski',
	Oznaczeniadozakładów: 'Oznaczenia do zakładów',
	regulations: 'Przepisy prawne',
	payment: 'Zapłata',
	privacyPolicy: 'Polityka prywatności i RODO',
	useFullLink: 'Przydatne linki',
	socialMedia: 'DOŁĄCZ DO NAS',
	facebook: 'Facebook',
	instagram: 'Instagram',
	youtube: 'YouTube',
	spotify: 'Spotify',
	twitter: 'Twitter',
	joinUs: 'Dołącz do nas',
	footerText:
		'BETFAN Sp. z o.o. z siedzibą w Warszawie (KRS 0000727637, NIP 5252747132, REGON 369967041) posiada zezwolenie (PS4.6831.3.2018) na urządzanie zakładów wzajemnych - bukmacherskich przez sieć Internet udzielone przez Ministra Finansów dnia 29 października 2018 roku na okres sześciu lat od dnia doręczenia decyzji. ',
	footerText2: 'BETFAN to legalny polski bukmacher. Hazard wiąże się z ryzykiem. Gra u nielicencjonowanych podmiotów jest niezgodna z prawem.',
	footerText3: 'Zakaz wstępu na stronę internetową i uczestnictwa w grze hazardowej dla osób poniżej 18 roku życia.',
	footerText4: '2024 © BETFAN Sp. z o.o.',
	sportBetfanBlog: 'Blog Sport Betfan',
	certificateOfWinning: 'Zaświadczenie o wygranej',
	youCanWin: 'Możesz wygrać',
	share: 'PODZIEL SIĘ',
	continuePlaying: 'GRAJ DALEJ',
	smsCodeValidation: 'Wymagany jest zarówno adres e-mail, jak i numer telefonu',
	change: 'ZMIEŃ',
	confirmation: 'POTWIERDZENIE',
	date: 'Data',
	since: 'Od:',
	until: 'Do:',
	alert: 'Alarm',
	code: 'Kod',
	month: 'Miesiąc',
	months: 'Miesiące',
	betsArePlaced: 'Kupon został postawiony',
	clearCoupon: 'Skasować kupon?',
	yourCoupon: 'Twój kupon',
	possibleWinnings: 'Możliwa wygrana',
	placingMoreTheSame: 'Stawiasz dalej tak samo?',
	iBelieve: 'Usuń',
	unAvailableBet: 'Zdarzenie niedostępne',
	winningDialogTitle: 'Twoja wygrana',
	betBuilder: 'BetBuilder',
	cashout: 'Cashout',
	myBet: 'My Bet',
	promoCodes: 'Kod',
	mobileApplication: 'Aplikacja Mobilna',
	help: 'pomoc',
	shortcut: 'NA SKRÓTY',
	ligielEktroniczne: 'Ligi elektroniczne',
	transmissions: 'Transmisje',
	rangiVip: 'Rangi VIP',
	refreshButton: 'Odśwież Kupon',
	couponDoesNotExist: 'kupon nie istnieje',
	checkCurrentOffer: 'sprawdź aktualną ofertę',
	copyCoupon: 'Kopiuj kupon',
	replaceCoupon: 'Masz już zdarzenia na kuponie. Czy chcesz je podmienić?',
	couponCopied: 'Kupon został skopiowany! Znajdziesz go w swoim koszyku',
	noEventCopied: 'Kupon nie może zostać skopiowany. Zdarzenia nie są już dostępne.',
	partiallyEventCopied: 'Kupon został skopiowany częściowo. Zdarzenia, które nie mogły być skopiowane, zostały pominięte',
	group: 'Grupa',
	listOfCombinations: 'Lista kombinacji',
	selectSystemSlipGroup: 'Przenieś do grupy:',
	sureBet: 'Pewniak',
	deleteSlip: 'Usuń zdarzenie',
	eventInPlural: 'zdarzenia',
	eventInSingular: 'zdarzenie',
	eventTxtMoreThan5: 'zdarzeń',
	androidApp: 'aplikacja Android',
	iosApp: 'aplikacja iOS',
	mobileBrowser: 'przeglądarka w telefonie”',
	terminalMachine: 'terminal',
	webBrowser: 'komputer',
	virtualBasketball: 'Wirtualna koszykówka',
	virtualDogRacing: 'Wirtualne wyścigi psów',
	virtualFootball: 'Wirtualna piłka nożna',
	virtualHorseRacing: 'Wirtualne wyścigi koni',
	outrights: 'zakłady długoterminowe',
	totalBalance: 'Saldo łączne',

	// new verification steps content
	verStep1Heading: '📫 Bądźmy w kontakcie',
	verStep2Heading: '📫 Zaadresuj marzenia',
	verStep3Heading: '💳 Wypłacaj wygrane',
	verStep4Heading: '😎 Graj legalnie',
	verStep5Heading: '😄 Uśmiech do zdjęcia',
	verStep6Heading: '🪪 Szczegóły dokumentu',
	verStep1Description: 'Podanie tych danych jest konieczne wyłącznie ze względów formalnych.',
	verStep2Description: 'Bez obaw! Nie będziemy nachodzić Cię w domu, a tym bardziej Pudzian.',
	verStep3Description: 'Numer konta bankowego i konto Gracza muszą mieć tego samego właściciela. ',
	verStep4Description: 'Ten PEP to nie Guardiola, dlatego jeśli chcesz dowiedzieć się czegoś więcej, kliknij “i”. ',
	verStep5Description: 'Sprawdź, czy dokument jest aktualny, kompletny, a dane są czytelne.',
	verStep6Description: 'Twoje dane będą zabezpieczone przez ministerstwo i Pudziana.',

	// account verification
	verificationAccountSuccessToast:
		'To wszystko. Twoje konto jest weryfikowane. Zwykle zajmuje to kilka godzin, a oczekiwanie nie powinno przekroczyć 48 godzin.',
	verificationSuccessTitle: 'Jesteś już zweryfikowany!',
	verificationSuccessDescription: 'Teraz pora na grę!',
	verificationStep1Title: 'Bądźmy w kontakcie',
	verificationStep1Description:
		'Bez obaw! Twoje dane są bezpieczne. To tylko wymóg formalny. My też nie ukrywamy, że nasz koń mieszka na Służewcu.',
	verificationStep1SubTitle: 'Uzupełnij miejsce zamieszkania',
	verificationStep1ModalTitle: 'Informacje adresowe',
	verificationStep1ModalDescription: 'Adres zamieszkania jest wymagany w celu zabezpieczenia Twojego konta i zapobiegania oszustwom.',
	verificationStep2Title: 'Czuj się bezpiecznie',
	verificationStep2Description: 'Sprawdź, czy dokument jest aktualny, kompletny, a dane są czytelne.',
	verificationStep2SubTitle: 'Uzupełnij adres zamieszkania',
	verificationStep2ModalTitle: '-',
	verificationStep2ModalDescription: '-',
	verificationStep3Title: 'Wypłacaj wygrane',
	verificationStep3Description: 'Numer konta bankowego i konto Gracza muszą mieć tego samego właściciela.',
	verificationStep3SubTitle: 'Wrzuć fotkę dokumentu tożsamości',
	verificationStep3ModalTitle: '-',
	verificationStep3ModalDescription: '-',
	verificationStep4Title: 'Graj legalnie',
	verificationStep4Description: 'Ten PEP to nie Guardiola, dlatego jeśli chcesz dowiedzieć się czegoś więcej, kliknij “i”.',
	verificationStep4SubTitle: 'Uzupełnij dane z dowodu:',
	verificationStep4ModalTitle: 'Informacje PEP',
	verificationStep4ModalDescription:
		'Oświadczam, że nie jestem/byłem osobą zajmującą EKSPONOWANE STANOWISKO POLITYCZNE oraz nie jestem członkiem rodziny ani bliskim współpracownikiem takiej osoby PEP. Czym jest PEP? Politically Exposed Persons to osoby fizyczne zajmujące eksponowane stanowiska polityczne lub pełniące znaczące funkcje publiczne.',
	verificationGenericTitle: 'Uzupełnij dane z dokumentu tożsamości',
	choose: 'Wybierz',
	passportData: 'Strona paszportu z danymi właściciela',
	addPhoto: 'Dodaj zdjęcie',
	verification: 'Weryfikacja',
	declaration: 'Deklaracja',
	documents: 'Dokumenty',
	correspondenceAddress: 'Adres korespondencyjny',
	bankAccount: 'Konto bankowe',
	verificationConfirmation: 'Potwierdzenie weryfikacji',
	declarationText:
		'Oświadczam, że nie jestem/byłem osobą zajmującą EKSPONOWANE STANOWISKO POLITYCZNE lub jestem członkiem rodziny albo bliskim współpracownikiem takiej osoby <1>(PEP)</1>.<3/><4/><5>Czym jest PEP?</5> Politically Exposed Persons to osoby fizyczne zajmujące eksponowane stanowiska polityczne lub pełniące znaczące funkcje publiczne',
	isPEP: 'Jestem PEP',
	notPEP: 'Nie jestem PEP',
	sourceOfIncome: 'Źródło dochodu',
	fundSource: 'Oświadczam, że środki przeznaczone na grę pochodzą z następującego źródła',
	fundSourceValidation: 'Wybierz jedno ze źródeł dochodu',
	remuneration: 'Wynagrodzenie za pracę lub inne umowy cywilnoprwane',
	economicActivity: 'Działalność gospodarcza',
	cashCapital: 'Dochody z kapitałów pieniężnych',
	decrease: 'Spadek',
	donation: 'Darowizna',
	pension: 'Emerytura lub renta',
	gamesOrContests: 'Wygrane w grach hazardowych lub konkursach',
	savings: 'Oszczędności',
	rentSublet: 'Dochód z najmu, podnajmu, dzierżawy, poddzierżawy oraz innych umów o podobnym charakterze',
	propertyIncome: 'Dochód z odpłatnego zbycia ruchomości lub nieruchomości',
	loan: 'Pożyczka',
	other: 'Inne',
	addDocumentTitle: 'Dodaj zdjęcie dokumentu',
	addDocumentTitle2: 'Sprawdź, czy dokument jest:',
	addDocumentInstructionReadability: 'Czytelny i kompletny',
	addDocumentInstructionName: 'Zawiera twoje imię i nazwisko',
	addDocumentInstructionCurrent: 'Jest aktualny',
	uploadDocument: ' Wybierz swój dokument',
	personalEvidence: 'Dowód osobisty',
	passport: 'Paszport',
	standingCardStay: 'Karta stałego pobytu',
	passportPage: 'Strona paszportu z danymi właściciela',
	uploadFront: 'Przód dokumentu',
	uploadBack: 'Tył dokumentu',
	seriesNumber: 'Seria i numer',
	expirationDate: 'Data ważności',
	fillMailAddressTitle: 'uzupełnij adres korespondencyjny',
	street: 'Ulica',
	streetNameLetterValidation: 'Wpisz prawidłową ulicę',
	buildingNumber: 'Numer budynku',
	buildingNumberDigitValidation: 'Numer powinien składać się conajmniej z jednej cyfry',
	apartmentNumber: 'Numer mieszkania',
	apartmentNumberDigitValidation: 'Wpisz prawidłowy numer mieszkania',
	city: 'Miasto',
	cityLengthValidation: 'Nazwa miasta powinna składać się conajmniej z dwóch liter',
	postalcode: 'Kod pocztowy',
	bankAccountNumberTitle: 'Uzupełnij numer konta bankowego do realizacji płatności',
	accountInstruction: 'Konto bankowe i konto Gracza musi należeć do tej samej osoby.',
	bankAccountNumber: 'Numer konta bankowego',
	writeYourAccountNumber: 'Wpisz numer konta bankowego:',
	verificationRequestConfirm: 'Dane zostały zapisane, zostaniesz poinformowany mailowo o zmianie statusu BETkonta.',
	residenceCard: 'Karta pobytu',
	imageSizeExceededVerifiction: 'Przekroczono maksymalny rozmiar zdjęcia (5MB)',
	wrongFileFormatVerification: 'Nieobsługiwany format pliku. Wgraj zdjęcie w formacie .jpeg lub .png',
	unsupportedFileVerification: 'Wprowadzone dane są nieprawidłowe. Nieobsługiwany format pliku.',
	verificationSerialIDIssue: 'Wystąpił problem z weryfikacją danych. Prosimy o dokładne sprawdzenie wprowadzonych informacji.',
	accountVerificationCancelPopup: 'Weryfikacja w toku… Przerwać?',

	// personal data
	contactDetails: 'Dane Kontaktowe',
	identification: 'Dokument Tożsamości',
	missingDocument: 'Brak dokumentu',
	changeDataDescription: 'W celu edycji danych, prosimy o kontakt z biurem obsługi gracza',
	goToChat: 'Przejdź do czatu',
	temporaryAccountConstraint: 'BETkonto tymczasowe z możliwością grania do 5000 zł.',
	expiredAccountConstraint: 'Twój dokument tożsamości stracił ważność',
	expiredAccountSubTitle: 'Aby móc w pełni korzystać z BETkonta, prosimy o wgranie aktualnego dokumentu tożsamości.',
	activateAccountRecommendation: 'Aby zwiększyć kwotę, zweryfikuj konto.',
	accountNumber: 'Numer Konta',
	citizenship: 'Obywatelstwo',
	changeAccountNumberText: 'Jeśli chcesz zmienić numer konta bankowego, skontaktuj się z Biurem Obsługi Gracza za pomocą E-MAILA bądź CZATU',
	DONOT_ACCEPT_ANY_ODDS: 'Nie akceptuj zmian kursów',
	ACCEPT_ANY_RATE_CHANGE: 'Akceptuj każdą zmianę kursów',
	ONLY_ACCEPT_HIGHER_RATES: 'Akceptuj tylko wyższe kursy',
	Combinations: 'Kombinacje',
	betSlipMessage: 'Twój kupon czeka na pierwszy zakład',
	todayOffer: 'Oferta na dziś',
	totalCourse: 'Kurs',
	changeStake: 'Stawka:',
	selectStake: 'Wybierz stawkę',
	changeStakeSystem: 'Stawka całkowita:',
	changeCombinationStakeSystem: 'Stawka kombinacji',
	simpleStackSystem: 'Wybierz całkowitą stawkę:',
	factor: 'Współczynnik',
	playAndWin: 'ZAGRAJ I WYGRAJ',
	logAndWin: 'Zaloguj się i wygrywaj',
	playAndWinFreebet: 'Graj o darmowy zakład i wygraj',
	buttonLogin: 'ZALOGUJ',
	placeBet: 'POSTAW ZAKŁAD',
	chooseEvent: 'WYBIERZ ZDARZENIE',
	docVerfInProgressInfo: 'Twoje dokumenty są w trakcie weryfikacji.',
	docVerfEmailInfo: 'Po akceptacji dokumentów poinformujemy cię mailowo.',
	docSent: 'Dokumenty przesłane',
	docSentInfo: 'Twoje dokumenty zostały przesłane do zatwierdzenia przez Biuro Obsługi Gracza.',
	oddsEventChanged: 'Kursy zdarzenia zmieniły się!',
	totalKurs: 'Kurs całkowity',
	slipErrorWarning5: 'Zdarzenia nie można łączyć z innymi na kuponie',
	slipErrorWarning33: 'Zdarzenia nie można łączyć z innym zdarzeniem na kuponie',
	slipErrorWarning75: 'Zdarzenia nie można łączyć z innymi zdarzeniami na kuponie',
	slipErrorWarning206: 'Zdarzenie rozpocznie się po czasie wygaśnięcia bonusu',
	slipErrorWarning98: 'Zdarzenia nie można łączyć z inną kategorią zdarzeń w tym kuponie',
	basicData: 'Podstawowe dane',

	// bonus
	active: 'Aktywne',
	waiting: 'Oczekujące',
	history: 'Historia',
	download: 'pobierz',
	installBanner: 'Aplikacja Betfan na iOS',
	iosAppDownload: 'Pobierz aplikację Betfan z App Store',
	installOurApp: 'Zainstaluj naszą apkę!',
	rate: 'Stawka',
	currentStack: 'Stawka',
	lastStack: 'OSTATNIA STAWKA',
	betAny: 'POSTAW WSZYSTKO',
	enterRate: 'Wpisz stawkę ręcznie',
	enterAmountManually: 'Wpisz kwotę ręcznie',
	backC: 'COFNIJ',
	cancelC: 'ANULUJ',
	inGame: 'W grze',
	wins: 'Wygrane',
	win: 'Wygrana',
	toWin: 'Do wygrania',
	calculatorError: 'nie możesz wybrać więcej niż 50000',
	seeMore: 'Zobacz więcej',
	seeLess: 'Zobacz mniej',
	bonus: 'Bonusy',

	// ako bonus
	addSlipsToBetslipForAkoBonus:
		'Dodaj jeszcze {{numOfCouponsToAdd}} {{eventText}} o kursie min. {{minOutcomeOdds}}, aby aktywować <strong>AKO Booster</strong> {{futureBonusValue}}%!',
	akoBonusNotAvailable: 'Ako Booster nie jest dostępny do gry z saldem freebetów/bonusów.',
	akoBoosterValue: 'AKO Booster {{currentBonusValue}}%',
	maxBonusAmountReached: 'Gratulacje, osiągnąłeś najwyższą możliwą kwotę AKO Boostera!',

	// cp coupon
	couponEmptyMessage: 'Czekamy na Twoje wygrane!',
	couponRedirectText: 'Postaw kupon i WYGRAJ!<1></1>Nie grasz, nie wygrasz!',
	winAmount: 'Kwota Wygrana',
	makeCashout: 'Dokonać Cashout?',
	cashoutSuccessTitle: 'Cashout zrealizowany',
	cashoutAmount: 'Kwota Cashout',
	cashoutNow: 'Wypłać teraz',
	checkCashout: 'Sprawdź dostępny cashout',
	refundAmount: 'Kwota Zwrotu',
	refund: 'Zwrot',
	dateOfConclusion: 'Data zawarcia',
	cardGamesInfo: 'Odwiedź sekcję historii w sekcji Gry karciane, aby poznać szczegóły transakcji',
	copyRefCode: 'Skopiowano!',
	usedBonus: 'Korzystasz z ',
	eventOutdated: 'Wydarzenie nie jest aktualne',
	eventAdded: 'Wydarzenie dodane',
	comeBackLater: 'Wróć później',
	cashoutUnavailable: 'W tym momencie cashout nie jest dostępny.',
	submitCashoutQuestion: 'Zlecić cashout?',
	submitCashoutYes: 'Zleć cashout',
	cashoutValue: 'Kwota:',

	// cp bonuses
	activeSince: 'Aktywny od',
	activeUntil: 'Aktywny do',
	value: 'Wartość',
	bonusAmount: 'Kwota bonusu',
	freebetAmount: 'Kwota freebet',
	amountToBeTraded: 'Kwota do obrotu',
	leftToMarket: 'Pozostało do obrotu',
	cancel2: 'ZREZYGNUJ',
	bonusEmptyMessage: 'Graj z Nami aby zdobywać BONUSY!',
	offerRedirectMessage: 'Sprawdź co dla Ciebie przygotowaliśy',
	checkItOut: 'SPRAWDŹ',
	pendingTabOfferMessage: 'Zobacz naszą ofertę promocji',
	historyTabOfferMessage: 'Aktywuj bonusy i zdobywaj nagrody',
	bonusWaivedMessage: 'Zrezygnowałeś z bonusu',
	bonusWaivedMessageInfo: 'Anulowano bonus:',
	bonusActivatedMessage: 'Nowy bonus został aktywowany',
	bonusActivatedInfo: 'Aktywowano kod:',
	bonusActivatedSubInfo: 'Kod będzie dostępny w zakładce:',
	optOutConfirmation: 'Czy chcesz zrezygnować z',
	optOutBonus: 'Anulować bonus?',
	optOutBonusInfo: 'Chcesz anulować bonus:',
	bonusActivationMessage: 'Tylko jeden bonus może być aktywny w tym samym czasie',
	bonusActivationErrorMessage: 'Posiadasz już aktywny bonus.',
	bonusInUseErrorMessage: 'Nie możesz anulować bonusu. Pozostały aktywne spotkania, które zostały postawione z bonusowych środków',

	//cp CoupanMessages
	aktualne: 'Aktualne',
	ended: 'Zakończona',

	//cpMessages
	noNews: 'Brak wiadomości',
	noNewsMessage: 'Gdy przygotujemy dla Ciebie coś specjalnego - skontaktujemy się z Tobą!',

	// lock text
	goToEvent: 'Przejdź do wydarzenia',
	noOdds: 'Brak kursu',

	//activity history
	activityHistory: 'Historia aktywności',
	activityHistoryDisabled: 'W związku ze zwiększonym ruchem ta część strony jest chwilowo niedostępna.',
	activityHistoryComeBack: 'Wróć za 30 minut!',

	// payout/deposit
	amount: 'Kwota',
	saveCard: 'Zapisz kartę do kolejnych płatności',
	savedCards: 'Zapisane karty',
	addNewCard: 'Dodaj nową kartę',
	payWithSavedCard: 'Użyj zapisanej karty',
	depositAmount: 'Kwota wpłaty',
	payoutAmount: 'Kwota wypłaty',
	payoutWarning: 'UWAGA! Masz aktywny bonus na swoim koncie. Jeśli zlecisz wypłatę, zostanie ona anulowana.',
	enterAmount: 'Wpisz kwotę',
	blikPayment: 'Płatność Blik',
	paymentMode: 'Wybierz Formę Płatności:',
	blikCode: 'Kod BLIK',
	enterBlikCode: 'Wpisz kod BLIK',
	saveBlikAlias: 'Zapamiętaj aplikację i pozwól mi płacić Blikiem.',
	useSavedBlikCodeText: 'Zapłać bez podawania kodu blik',
	enterBlikCodeText: 'Chcę wprowadzić kod blik',
	blikRegulationAccept: 'Płacąc oświadczam, że zapoznałem się z regulaminem i obowiązkiem informacyjnym serwisu Przelewy24.',
	bankTransfer: 'Przelew, Paysafecard, Google Pay i inne',
	bankTransferConsent:
		'I consent to the payment by the payment provider PayPro S.A., based in Poznań at ul. Kanclerska 15, 60-357 Poznań to the Betfan Company with its seat in Warsaw (01-523) at ul. Śmiała 26, data including the name and surname, address and bank account number, the registration of which is necessary to fulfill the obligations imposed by legal regulations on the BETFAN Company, for the purposes related to the performance of these obligations. I have read and I accept the terms and conditions of the Przelewy24 Website',
	bankTransferInfo:
		'<0>Informacja!</0> Niektóre banki pobierają dodatkowe opłaty przy przelewach do zakładów bukmacherskich - jeśli Twój bank pobiera dodatkową opłatę skorzystaj z innych form płatności - zalecamy: Blik',
	deleteCard: 'Czy na pewno chcesz usunąć zapisaną kartę?',
	additionalAuth: 'Przejdź do autoryzacji',
	cardPayment: 'Płatność Kartą',
	cardOwner: 'Właściciel Karty',
	cardNumber: 'Numer Karty',
	expirationDetails: 'Wygasa ( M/R )',
	cvvCode: 'Numer CVV/CVC',
	cardSaveAlias: 'Zapamiętaj aplikacje i pozwól mi płacić Blikiem.',
	cardAcceptRegulation: 'Akceptacja regulamin pojedynczej płatności Przelewy24',
	payOrderAcceptedText: 'Przyjeliśmy zlecenie wpłaty',
	payOrderAcceptedTitleForBlink: 'Potwierdzenie płatności',
	payOrderAcceptedTextForBlink: 'Potwierdź płatność w aplikacji banku na kwotę:',
	payOrderError: 'Nie mogliśmy przyjąć Twojej wpłaty',
	withdrawalAmount: 'Kwota do wypłaty:',
	fundsRecommendation: 'Warto pozostawić środki na koncie i skorzystać z przygotowanych dla Ciebie promocji.',
	withdrawalRequest: 'Dokonać wypłaty?',
	withdrawalRequestAccepted: 'Twoja wypłata została zlecona',
	paymentOrderAccepted: 'Wpłacona kwota:',
	notEnoughFunds: 'Kwota nie może przekroczyć dostępnego salda',
	payout_respcode_32: 'Hasło niepoprawne',
	selectBank: 'Wybierz jeden z wyżej wymienionych banków',
	cardExpiryDateValidationText: 'Podaj prawidłową datę ważności w formacie (MM/RR)',
	unverifiedPayoutTitle: 'Wypłata nie jest możliwa',
	unverifiedPayoutText: 'Aby wypłacić środki należy dokonać pierwszego depozytu i zweryfikować dokumenty',
	verifyBankAccountTitle: 'Wypłata nie jest możliwa',
	verifyBankAccountText:
		'Aby wypłacać wygrane prosimy o weryfikację konta bankowego. Prześlij na adres bog@betfan.pl potwierdzenie transakcji zasilającej Twoje BETkonto z Twojego konta bankowego.',
	goBackToTheGame: 'Wróć do gry',
	incorrectBlikCode: 'Wprowadzony kod BLIK jest niepoprawny.',
	deposits: 'Wpłaty',
	methodBlikNoCode: 'BLIK bez kodu',
	noCode: 'BEZ KODU',
	methodBlik: 'BLIK',
	methodPrzelewy24: 'Przelewy24 (w tym Apple & Google Pay)',
	methodGooglePay: 'Google Pay',
	methodCard: 'Karta płatnicza (w tym Revolut)',
	methodTransfer: 'Szybki przelew',
	verificationPending: 'Nie możesz dokonać wpłaty, bo dokumenty są jeszcze w trakcie weryfikacji. Może to potrwać do 48 godzin. Spróbuj później.',
	verificationPendingPayout:
		'Nie możesz dokonać wypłaty, bo dokumenty są jeszcze w trakcie weryfikacji. Może to potrwać do 48 godzin. Spróbuj później.',
	verifyAccount: 'Weryfikuję się!',
	depositUnavaiableHeader: 'Wystąpił błąd',
	depositUnavaiableMessage: 'Pojawił się problem z pobraniem wymaganych danych.',
	depositUnavaiableTryAgain: 'Spróbuj ponownie za chwilę',
	depositMaintenanceHeader: 'Wystąpił błąd',

	// promocode
	enterYourPromoCode: 'Wpisz swój kod promocyjny',
	enterCode: 'Wpisz kod',
	promoCode: 'Kod promocyjny',
	invalidPromoCode: 'Nieprawidłowy kod promocyjny!',
	alreadyRedeemed: 'Kod promocyjny już wykorzystany!',
	promoCodeError: 'Nie można aktywować tego bonusu',
	promoCodeApplied: 'Kod promocyjny aktywowany',
	promoCodeExhausted: 'Limit kodów promocyjnych wyczerpany!',
	promoCodeUnavailable: 'Kod promocyjny nie jest teraz dostępny! Spróbuj ponownie później.',
	promoCodeExclusive: 'Kod promocyjny jest ważny tylko dla ograniczonych użytkowników!',
	promoCodeInactive: 'Kod promocyjny nie jest aktywny!',
	promoCodeExpired: 'Kod promocyjny wygasł!',
	promoCodeBlocked: 'Kod promocyjny nie jest dla Ciebie dostępny!',

	// responsibleGame
	rgLimits: 'Limity',
	rgActivities: 'Aktywności',
	rgTransactions: 'Transakcje',
	rgRegulations: 'Regulaminy',
	rgRegulationsAndDocuments: 'Regulaminy i dokumenty',

	// limits
	dailyLimitMaxed: 'Dzienny limit stawek został wykorzystany. Aby wrócić do gry poczekaj do jutra lub zmień limit.',
	monthlyLimitMaxed: 'Miesięczny limit stawek został wykorzystany. Aby wrócić do gry poczekaj do następnego miesiąca lub zmień limit',
	limitAwaitingChangeInformation: `Zmiana limitu z {{from}} na {{to}} nastąpi {{date}} o {{time}}.`,
	limitsRange: 'Zakres:',
	limitIncrease: 'Zwiększasz limit.',
	limitDecrease: 'Zmniejszasz limit.',
	limitsDecreaseInformation: `<b>Zmniejszasz limit.</b> Zmiana limitu nastąpi od razu po zapisaniu ustawień.`,
	limitsHeading: 'Zasady Odpowiedzialnej Gry',
	limitsTitle: 'Limity gry',
	limitsInfoDescription: `<b>WAŻNE:</b> Zgodnie z zasadami Odpowiedzialnej Gry, zwiększenie przez gracza któregokolwiek z limitów,o których mowa, dokonywane jest następująco:`,
	limitsInfoListHours: `<b>pierwsze zwiększenie limitu - po upływie 24h</b> od chwili zgłoszenia takiego żądania przez gracza`,
	limitsInfoListWeeks: `<b>drugie zwiększenie limitu - po tygodniu</b> od chwili zgłoszenia takiego żądania przez gracza`,
	limitsInfoListMonths: `<b>trzecie i każde kolejne zwiększenie limitu - po upływie 3 miesięcy</b> od chwili zgłoszenia takiego żądania przez gracza.`,
	limitsInfoDecrease: 'Zmniejszanie limitów nastąpi natychmiastowo',
	limitsMaxValueValidation: '{{field}} nie może wynosić więcej niż {{value}}{{unit}}',
	limitsMinValueValidation: '{{field}} nie może wynosić mniej niż {{value}}{{unit}}',
	limitsSubmitSuccessToast: 'Limity zostały pomyślnie zaktualizowane',
	lastUpdate: 'Ostatnia aktualizacja',
	dailyStakeLimit: 'Dzienny limit stawek',
	monthlyStakeLimit: 'Miesięczny limit stawek',
	dailyGameLimit: 'Dzienny limit czasu gry',
	monthlyGameLimit: 'Miesięczny limit czasu gry',
	accounts: 'KONTA',
	closeAccount: 'Zamknąć konto?',
	closeAccountDescription: 'Ta opcja pozwoli Ci permanentnie zamknąć swoje konto.',
	accountClosureInformation:
		'Zamknięcie Twojego konta spowoduje brak możliwości zawierania zakładów oraz logowania bezterminowo.<1></1><2></2>Późniejsze prośby o ponowne otworzenie konta rozpatrywane są indywidualnie po uprzednim kontakcie z Biurem Obsługi Gracza.',
	accountClosed: 'Konto zamknięte',
	suspendAccount: 'Konto zawieszone',
	suspendAccountTitle: 'Zawiesić konto?',
	suspendAccountDescription: 'Czy na pewno chcesz zawiesić swoje konto? Zawieszenie będzie aktywne przez 1 dzień.',
	suspendConfirm: 'Zawieszenie będzie aktywne przez <1>1 dzień.</1>',
	selfExclusion: 'Samowykluczenie',
	selfExclusionTitle: 'Dezaktywować konto na 3 miesiące?',
	selfExclusionDescription: 'Ta opcja pozwoli Ci zablokować swoje konto na okres 3 miesięcy.',

	changeOfLimits: 'Zmienić limity gry?',
	limitsInfo: `Informujemy, iż w przypadku zmian limitów na koncie czas autoryzacji wynosi:
		<br/>
		1 zmiana limitów <strong>- 24h</strong>
		<br/>
		2 zmiana limitów <strong>- 7 dni</strong>
		<br/>
		3 i kolejna zmiana limitów <strong>- 3 miesiące</strong>
	`,
	otherSettings: 'Inne',
	deactivateAccountButton: 'Dezaktywuj konto',
	closeAccountTitle: 'Zamknięcie konta',
	closeAccountButton: 'Zamknij konto',
	suspendAccountDropdownTitle: 'Zawieszenie konta',
	suspendAccountButton: 'Zawieś konto',
	limitUpdateMessage: 'Pomyślnie zaktualizowano limity!',
	limitChangeInfo: 'W celu zmiany limitów skontaktuj się z Biurem Obsługi Gracza - mailowo na adres bog@betfan.pl lub za pomocą czatu',

	// transactions
	allOfThem: 'Wszystkie',
	paymentByCard: 'Płatność kartą',
	sessionTime: 'Czas sesji',
	regulation: 'Regulamin',
	bonusDeposit: 'Depozyt bonusowy',
	withdrawalToBank: 'Wypłata na rachunek bankowy',
	withdrawRequestCancel: 'Zlecenie wypłaty anulowane',
	recognition: 'Uznania',
	rollBackByAdmin: 'Cofnięcie środków',
	transferBonusFunds: 'Przeniesienie środków bonusowych',
	pendingTransaction: 'Zlecona',
	currency: 'zł',
	decimal: ',',

	// cp marketing consents
	emailMarketingConsent:
		'Wyrażam zgodę na przetwarzanie przez BETFAN Sp. z o.o. moich danych osobowych w celach marketingowych, w tym na otrzymywanie informacji E-MAIL',
	smsMarketingConsent:
		'Wyrażam zgodę na przetwarzanie przez BETFAN Sp. z o.o. moich danych osobowych w celach marketingowych, w tym na otrzymywanie informacji SMS',

	// language
	selectLanguage: 'Wybierz język',
	english: 'Angielski',
	polish: 'Polski',
	ukrainian: 'Ukraiński',

	// entertainment
	all: 'Wszystko',
	politics: 'Polityka',
	current: 'Na czasie',
	sports: 'Wokół sportu',
	validUntil: 'Ważny do',
	eventEndsIn: 'Zdarzenie kończy się za:',

	// promotion
	join: 'Dołącz',
	constant: 'Stałe',
	temporary: 'Czasowe',
	viewPromotionBtn: 'Zobacz Promocję',
	TimedOffer: 'Oferta Czasowa',
	promotionFinishDescription: 'Promocja zakończy się za:',
	promotionSignUpButton: 'Dołącz do promocji',
	promotionSignUpPopupDescription: 'Gratulacje, zapisałeś się do promocji!',
	alreadySignedUpPromotionTitle: 'Informacja',
	alreadySignedUpPromotionDescription: 'Już jesteś zapisany do promocji. Powodzenia!',
	promotionAboutBetfan: 'BETFAN to legalny polski bukmacher. Powstaliśmy, aby każdego dnia dostarczać niepowtarzalną i unikatową porcję rozrywki.',
	promotionExpired: 'Promocja wygasła i nie jest już dostępna',
	promotionNotExisting: 'Promocja nie istnieje',

	//betType
	akoBetType: 'Ako',
	soloBetType: 'Solo',
	systemBetType: 'System',
	deleteBetsMessage: 'Na pewno? Możesz wygrać:',
	clearCoupan: 'SKASOWAĆ KUPON',
	deleteEverything: 'Skasuj wszystko',
	minimuStackValue: 'Kwota zakładu powinna wynosić co najmniej 2 zł',

	//sportPage
	popular: 'Popularne',
	disciplines: 'Dyscypliny',
	noEvent: 'Brak wydarzeń w wybranym okresie.',
	hours: ' godz.',
	betsAZ: 'Zakłady A-Z',
	checkAllMatches: 'Sprawdź wszystkie mecze',
	checkAllLiveMatches: 'Sprawdź wszystkie mecze LIVE',

	//gameType
	gameFilters_gameType_201: '1X2',
	gameFilters_gameType_202: 'Zwycięzca',
	gameFilters_gameType_203: 'Mecz - liczba goli',
	gameFilters_gameType_210: 'Handicap',
	gameFilters_gameType_220: 'Mecz - liczba punktów',
	gameFilters_gameType_2201: 'Handicap',
	gameFilters_gameType_2208: 'Handicap',
	gameFilters_gameType_221: 'Zwycięzca seta',
	gameFilters_gameType_2211: 'Handicap punktowy',
	gameFilters_gameType_235: '1. set - liczba punktów',
	gameFilters_gameType_238: 'Pozostała część meczu',
	gameFilters_gameType_2388: 'Następny gol',
	gameFilters_gameType_2396: 'Mecz - liczba punktów',
	gameFilters_gameType_2397: '1. drużyna - liczba punktów',
	gameFilters_gameType_2398: '2. drużyna - liczba punktów',
	gameFilters_gameType_240: 'Następny gol',
	gameFilters_gameType_245: 'Obie drużyny strzelą gola',
	gameFilters_gameType_249: 'Zwycięzca',
	gameFilters_gameType_2563: 'Zwycięzca',
	gameFilters_gameType_2569: '1. zawodnik - liczba gemów',
	gameFilters_gameType_257: 'Mecz - liczba gemów',
	gameFilters_gameType_2570: '2. zawodnik - liczba gemów',
	gameFilters_gameType_297: '1. drużyna - liczba goli',
	gameFilters_gameType_298: '2. drużyna - liczba goli',
	gameFilters_gameType_347: 'Zakład bez remisu',
	gameFilters_gameType_623: 'Handicap gemowy',
	gameFilters_gameType_6555: 'Następna bramka',
	gameFilters_gameType_659: 'Inningi 1 do 5 - liczba punktów',
	gameFilters_gameType_624: 'X set - handicap gemowy',
	gameFilters_gameType_258: 'X. set - poniżej/powyżej gemów',
	gameFilters_gameType_2214: 'X set - handicap punktowy',
	gameFilters_gameType_3049: 'X mapa - zwycięzca (z dogrywką)',
	gameFilters_gameType_3006: 'Poniżej/powyżej X map',
	gameFilters_gameType_209: 'Handicap 3-drogowy',

	// marketType
	marketType_0: 'Wszystkie',
	marketType_1: 'Główne',
	marketType_10: 'Spalone',
	marketType_11: 'Indywidualne',
	marketType_13: 'Poza polem',
	marketType_14: '1. połowa',
	marketType_15: 'Gole',
	marketType_16: '2. połowa',
	marketType_17: 'Handicap',
	marketType_18: 'Pozostałe',
	marketType_186: 'Promocje',
	marketType_19: 'Punkty',
	marketType_2: 'Rzuty rożne',
	marketType_20: 'Kwarta',
	marketType_21: '1. kwarta',
	marketType_22: '2. kwarta',
	marketType_23: '3. kwarta',
	marketType_24: '4. kwarta',
	marketType_3: 'Kartki i faule',
	marketType_33: 'Kartki',
	marketType_34: 'Faule',
	marketType_35: 'Nieparzyste / Parzyste',
	marketType_36: 'Dokładny wynik',
	marketType_39: 'Handicap',
	marketType_4: 'Poniżej/Powyżej',
	marketType_40: 'Zakłady specjalne',
	marketType_41: 'Szybkie zakłady',
	marketType_43: 'Zakłady na mapę',
	marketType_44: '2. mapa',
	marketType_45: '3. mapa',
	marketType_46: 'Zakłady na set',
	marketType_47: 'Zakłady na Inningi',
	marketType_48: 'Łączone',
	marketType_49: 'Zakłady na tercję',
	marketType_5: 'Drużynowe',
	marketType_50: 'Statystki drużynowe',
	marketType_51: 'Strzelcy',
	marketType_52: 'Zakłady łączone',
	marketType_53: 'PLAYER BETS',
	marketType_54: 'Statystyczne',
	marketType_55: 'Ilość ind. zwycięstw',
	marketType_57: 'Liczba 180',
	marketType_6: 'Strzały',
	marketType_7: 'Rozpoczęcie',
	marketType_8: 'Czas',
	marketType_9: 'Sub',
	marketType_All: 'Wszystko',
	marketType_Builder: `Bet Builder`,

	gameType_8: 'Poniżej/powyżej X goli',
	gameType_13: 'Poniżej/powyżej X kartek',
	gameType_23: 'Poniżej/powyżej X rzutów rożnych',
	gameType_52: '{{participant}} poniżej/powyżej X goli',
	gameType_53: '{{participant}} poniżej/powyżej X goli',
	gameType_105: '1 połowa - poniżej/powyżej X rzutów rożnych',
	gameType_110: '1 połowa - poniżej/powyżej X goli',
	gameType_115: '{{participant}} - poniżej/powyżej X rzutów rożnych',
	gameType_116: '{{participant}} - poniżej/powyżej X rzutów rożnych',
	gameType_117: '1 połowa - {{participant}} - poniżej/powyżej X goli ',
	gameType_118: '2 połowa - {{participant}} - poniżej/powyżej X goli',
	gameType_119: '2 połowa - {{participant}} - poniżej/powyżej X goli',
	'gameType_-284': '1 połowa - poniżej/powyżej',
	'gameType_-286': '2 połowa - poniżej/powyżej',
	'gameType_-6008': '1 połowa - handicap',
	'gameType_-2556': '2 połowa - dokładny wynik',
	'gameType_-2557': '1 połowa - handicap',
	gameType_74: '1 połowa - dokładny wynik',
	'gameType_-2975': 'Rzuty rożne handicap',
	'gameType_-458': 'Handicap',
	'gameType_-6009': '2 połowa - handicap',
	'gameType_-30260': 'Zawodnik strzeli przynajmniej dwa gole',
	gameType_134: '1. połowa - poniżej/powyżej X kartek',
	'gameType_-2954': '1. połowa - rzuty rożne handicap',
	'gameType_-6048': 'Handicap',
	'gameType_-30242': 'Liczba celnych strzałów na bramkę - poniżej/powyżej X',
	'gameType_-30243': 'Liczba fauli - poniżej/powyżej X',
	'gameType_-30241': 'Posiadanie piłki - {{participant}} poniżej/powyżej X procent',
	'gameType_-200066': '{{participant}} poniżej/powyżej X kartek',
	'gameType_-200067': '{{participant}} poniżej/powyżej X kartek',
	gameType_162: '{{participant}} - Liczba fauli - poniżej/powyżej X',
	gameType_163: '{{participant}} - Liczba fauli - poniżej/powyżej X',
	gameType_168: '{{participant}}- Liczba celnych strzałów na bramkę - poniżej/powyżej X',
	gameType_169: '{{participant}}- Liczba celnych strzałów na bramkę - poniżej/powyżej X',
	'gameType_-30170': 'Poniżej/powyżej X żółtych kartek',
	'gameType_-200165': `{{participant}} - Liczba spalonych - poniżej/powyżej X`,
	'gameType_-30244': 'Liczba spalonych - poniżej/powyżej X',
	'gameType_-200191': '1. połowa: Liczba fauli - poniżej/powyżej X',
	'gameType_-200177': 'Handicap fauli',
	'gameType_-200194': 'Liczba strzałów - poniżej/powyżej X',
	'gameType_-200054': '{{participant}} - Liczba strzałów - poniżej/powyżej X',
	'gameType_-200055': '{{participant}} - Liczba strzałów - poniżej/powyżej X',

	// countries
	AD: 'Andora',
	AE: 'Zjednoczone Emiraty Arabskie',
	AF: 'Afganistan',
	AG: 'Antigua i Barbuda',
	AI: 'Anguilla',
	AL: 'Albania',
	AM: 'Armenia',
	AN: 'Antyle Holenderskie',
	AO: 'Angola',
	AQ: 'Antarktyda',
	AR: 'Argentyna',
	AS: 'Samoa Amerykańskie',
	AT: 'Austria',
	AU: 'Australia',
	AW: 'Aruba',
	AX: 'Wyspy Alandzkie',
	AZ: 'Azerbejdżan',
	BA: 'Bośnia i Hercegowina',
	BB: 'Barbados',
	BD: 'Bangladesz',
	BE: 'Belgia',
	BF: 'Burkina Faso',
	BG: 'Bułgaria',
	BH: 'Bahrajn',
	BI: 'Burundi',
	BJ: 'Benin',
	BM: 'Bermudy',
	BN: 'Brunei Darussalam',
	BO: 'Boliwia',
	BR: 'Brazylia',
	BS: 'Bahamy',
	BT: 'Bhutan',
	BV: 'Wyspa Bouveta',
	BW: 'Botswana',
	BY: 'Białoruś',
	BZ: 'Belize',
	CA: 'Kanada',
	CC: 'Wyspy Kokosowe',
	CD: 'Demokratyczna Republika Konga (Zaire)',
	CF: 'Republika Środkowoafrykańska',
	CG: 'Kongo',
	CH: 'Szwajcaria',
	CI: 'Wybrzeże Kości Słoniowej',
	CK: 'Wyspy Cooka',
	CL: 'Chile',
	CM: 'Kamerun',
	CN: 'Chiny',
	CO: 'Kolumbia',
	CR: 'Kostaryka',
	CS: 'Serbia i Czarnogóra',
	CU: 'Kuba',
	CV: 'Republika Zielonego Przylądka',
	CX: 'Wyspa Bożego Narodzenia',
	CY: 'Cypr',
	CZ: 'Czechy',
	DE: 'Niemcy',
	DJ: 'Dżibuti',
	DK: 'Dania',
	DM: 'Dominika',
	DO: 'Dominikana',
	DZ: 'Algeria',
	EC: 'Ekwador',
	EE: 'Estonia',
	EG: 'Egipt',
	EH: 'Sahara Zachodnia',
	ER: 'Erytrea',
	ES: 'Hiszpania',
	ET: 'Etiopia',
	FI: 'Finlandia',
	FJ: 'Fidżi',
	FK: 'Falklandy',
	FM: 'Mikronezja',
	FO: 'Wyspy Owcze',
	FR: 'Francja',
	GA: 'Gabon',
	GB: 'Wielka Brytania',
	GD: 'Grenada',
	GE: 'Gruzja',
	GF: 'Gujana Francuska',
	GG: 'Guernsey',
	GH: 'Ghana',
	GI: 'Gibraltar',
	GL: 'Grenlandia',
	GM: 'Gambia',
	GN: 'Gwinea',
	GP: 'Guadeloupe',
	GQ: 'Gwinea Równikowa',
	GR: 'Grecja',
	GS: 'Georgia Południowa i Sandwich Południowy',
	GT: 'Gwatemala',
	GU: 'Guam',
	GW: 'Gwinea Bissau',
	GY: 'Gujana',
	HK: 'Hong Kong',
	HM: 'Wyspy Heard i McDonalda',
	HN: 'Honduras',
	HR: 'Chorwacja',
	HT: 'Haiti',
	HU: 'Węgry',
	ID: 'Indonezja',
	IE: 'Irlandia',
	IL: 'Izrael',
	IM: 'Wyspa Man',
	IN: 'India',
	IO: 'Brytyjskie Terytorium Oceanu Indyjskiego',
	IQ: 'Irak',
	IR: 'Iran',
	IS: 'Islandia',
	IT: 'Włochy',
	JE: 'Jersey',
	JM: 'Jamajka',
	JO: 'Jordania',
	JP: 'Japonia',
	KE: 'Kenia',
	KG: 'Kirgistan',
	KH: 'Kambodża',
	KI: 'Kiribati',
	KM: 'Komory',
	KN: 'Saint Kitts and Nevis',
	KP: 'Korea Północna',
	KR: 'Korea Południowa',
	KW: 'Kuwejt',
	KY: 'Kajmany',
	KZ: 'Kazachstan',
	LA: 'Laos',
	LB: 'Liban',
	LC: 'Saint Lucia',
	LI: 'Liechtenstein',
	LK: 'Sri Lanka',
	LR: 'Liberia',
	LS: 'Lesotho',
	LT: 'Litwa',
	LU: 'Luksemburg',
	LV: 'Łotwa',
	LY: 'Libia',
	MA: 'Maroko',
	MC: 'Monako',
	MD: 'Mołdawia',
	ME: 'Czarnogóra',
	MG: 'Madagaskar',
	MH: 'Wyspy Marshalla',
	MK: 'Macedonia',
	ML: 'Mali',
	MM: 'Mjanma',
	MN: 'Mongolia',
	MO: 'Makau',
	MP: 'Mariany Północne',
	MQ: 'Martynika',
	MR: 'Mauretania',
	MS: 'Montserrat',
	MT: 'Malta',
	MU: 'Mauritius',
	MV: 'Malediwy',
	MW: 'Malawi',
	MX: 'Meksyk',
	MY: 'Malezja',
	MZ: 'Mozambik',
	NA: 'Namibia',
	NC: 'Nowa Kaledonia',
	NE: 'Niger',
	NF: 'Norfolk',
	NG: 'Nigeria',
	NI: 'Nikaragua',
	NL: 'Holandia',
	NO: 'Norwegia',
	NP: 'Nepal',
	NR: 'Nauru',
	NU: 'Niue',
	NZ: 'Nowa Zelandia',
	OM: 'Oman',
	PA: 'Panama',
	PE: 'Peru',
	PF: 'Polinezja Francuska',
	PG: 'Papua-Nowa Gwinea',
	PH: 'Filipiny',
	PK: 'Pakistan',
	PL: 'Polska',
	PM: 'Saint Pierre and Miquelon',
	PN: 'Pitcairn',
	PR: 'Portoryko',
	PS: 'Terytoria Palestyńskie',
	PT: 'Portugalia',
	PW: 'Palau',
	PY: 'Paragwaj',
	QA: 'Katar',
	RE: 'Reunion',
	RO: 'Rumunia',
	RS: 'Serbia',
	RU: 'Rosja',
	RW: 'Rwanda',
	SA: 'Arabia Saudyjska',
	SB: 'Wyspy Salomona',
	SC: 'Seszele',
	SD: 'Sudan',
	SE: 'Szwecja',
	SG: 'Singapur',
	SH: 'Wyspa Świętej Heleny',
	SI: 'Słowenia',
	SJ: 'Svalbard i Jan Mayen',
	SK: 'Słowacja',
	SL: 'Sierra Leone',
	SM: 'San Marino',
	SN: 'Senegal',
	SO: 'Somalia',
	SR: 'Surinam',
	ST: 'Wyspy Świętego Tomasza i Książęca',
	SV: 'El Salvador',
	SY: 'Syria',
	SZ: 'Suazi',
	TC: 'Turks i Caicos',
	TD: 'Czad',
	TF: 'Francuskie Terytoria Południowe',
	TG: 'Togo',
	TH: 'Tajlandia',
	TJ: 'Tadżykistan',
	TK: 'Tokelau',
	TL: 'Timor Wschodni',
	TM: 'Turkmenistan',
	TN: 'Tunezja',
	TO: 'Tonga',
	TR: 'Turcja',
	TT: 'Trynidad i Tobago',
	TV: 'Tuvalu',
	TW: 'Tajwan',
	TZ: 'Tanzania',
	UA: 'Ukraina',
	UG: 'Uganda',
	UM: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych',
	US: 'Stany Zjednoczone',
	UY: 'Urugwaj',
	UZ: 'Uzbekistan',
	VA: 'Watykan',
	VC: 'Saint Vincent i Grenadyny',
	VE: 'Wenezuela',
	VG: 'Brytyjskie Wyspy Dziewicze',
	VI: 'Wyspy Dziewicze Stanów Zjednoczonych',
	VN: 'Wietnam',
	VU: 'Vanuatu',
	WF: 'Wallis i Futuna',
	WS: 'Samoa',
	YE: 'Jemen',
	YT: 'Majotta',
	ZA: 'Republika Południowej Afryki',
	ZM: 'Zambia',
	ZW: 'Zimbabwe',
	goToLive: 'POWRÓT DO OFETY LIVE',
	returnToLive: 'Wróć do oferty LIVE',
	adjustingOurCourses: 'Ustawiamy nasze kursy',
	eventFinished: 'Wydarzenie zakończone',
	eventStarted: 'To wydarzenie się rozpoczęło',

	// regulations type
	privacyRegulation: 'REGULAMINY',
	vipRegulation: 'REGULAMINY VIP',
	promotionRegulation: 'REGULAMINY PROMOCJI',
	privacyPolicyRegulation: 'POLITYKA PRYWATNOŚCI',
	gdprRegulation: 'RODO',

	//errorcodes
	error1: 'Nie masz wystarczających środków na koncie, aby postawić zakład',
	error10: 'Przekroczono limit maksymalnej wygranej. Skontaktuj się z Biurem Obsługi Gracza',
	error100: 'Przepraszamy wystąpił błąd przy postawieniu zakładu. Skontaktuj się z Biurem Obsługi Gracza',
	error11: 'Aktualnie możesz postawić {0} lub poczekaj na zmianę limitów',
	error110: 'Nie spełniono warunku minimalnego kursu ogólnego kuponu',
	error111: 'Przekroczono wartość maksymalnego kursu ogólnego na kuponie',
	error112: 'Nie osiągnięto warunku minimalnej ilości zdarzeń na kuponie',
	error113: 'Przekroczono maksymalną liczbę zdarzeń na kuponie',
	error114: 'Zdarzenie jest aktualnie niedostępne. Spróbuj za chwilę lub skontaktuj się z Biurem Obsługi Gracza',
	error115: 'Zdarzenie jest aktualnie niedostępne. Spróbuj za chwilę lub skontaktuj się z Biurem Obsługi Gracza',
	error12: 'Aktualnie możesz postawić {0} lub poczekaj na zmianę limitów',
	error13: 'Osiągnięto limit nałożony na stawkę. Skontaktuj się z Biurem Obsługi Gracza',
	error15: 'Limit możliwej maksymalnej wygranej został osiągnięty',
	error16: 'Limit możliwych przegranych został przekroczony',
	error17: 'Aby wykorzystać bonus lub freebet, musisz zagrać kupon o kursie min. {{0}}. Zwiększ kurs, aby zagrać.',
	error18: 'Kursy zdarzenia zmieniły się',
	error19: 'Nie możesz postawić zakładu. Twoje konto zostało zamknięte',
	error2: 'Aby postawić zakład musisz się zalogować',
	error20: 'Zawieranie zakładów zostało zablokowane. Skontaktuj się z Biurem Obsługi Gracza',
	error204: 'Nie można postawić zakładu na to samo zdarzenie z salda depozytowego i bonusowego',
	error205: 'Kupon nie spełnia warunków obrotu bonusem',
	error206: 'Niektóre zdarzenia rozpoczną się po czasie wygaśnięcia bonusu',
	error207: 'Kupon nie został zaakceptowany',
	error209: 'Bonus lub freebet może być wykorzystany tylko na zakład {{0}}. Zmodyfikuj kupon i spróbuj ponownie.',
	error21: 'Minimalna stawka wynosi {{0}} zł. Dostosuj stawkę, aby zagrać',
	error210: 'Maksymalna stawka, za jaką możesz zagrać ten kupon, wynosi {{0}}. Zmniejsz stawkę i spróbuj ponownie.',
	error211: 'Bonus lub freebet może być wykorzystany tylko na zakład {{0}}. Zmodyfikuj kupon i spróbuj ponownie.',
	error212: 'Bonus zablokowany. Nie spełniono warunku obrotu depozytem',
	error214: 'Bonus lub freebet może być wykorzystany tylko na zakłady z kategorii {{0}}. Zmodyfikuj kupon i spróbuj ponownie.',
	error215: 'Nie znaleziono bonusu',
	error216: 'Spełniono już wszystkie warunki obrotu bonusem',
	error230: 'Została przekroczona maksymalna stawka na zdarzenie',
	error231: 'Maksymalny wkład dla jednego ze zdarzeń został przekroczony',
	error24: 'Stawianie zakładów zablokowane. Skontaktuj się z Biurem Obsługi Gracza',
	error28: 'Za krótki odstęp między kuponami',
	error29: 'Aby wykorzystać bonus lub freebet, musisz zagrać kupon o kursie max. {{0}}. Zmniejsz kurs, aby zagrać.',
	error3: 'Za dużo zakładów z jednego wydarzenia',
	error30: 'Twój zakład zostanie przesłany do akceptacji. Czy zgadzasz się na to?',
	error31: 'Twój zakład zostanie przesłany do akceptacji. Czy zgadzasz się na to?',
	error301: 'Kupon został odrzucony',
	error305: 'Błąd połączenia z serwisem live. Spróbuj ponownie lub skontaktuj się z Biurem Obsługi Gracza',
	error32: 'Aby wykorzystać bonus lub freebet, musisz zagrać kupon z min. {{0}} zdarzeniami. Dostosuj kupon i spróbuj ponownie.',
	error33: 'Niektóre zdarzenia nie mogą być łączone',
	error34: 'Aby wykorzystać bonus lub freebet, musisz zagrać kupon z max. {{0}} zdarzeniami. Dostosuj kupon i spróbuj ponownie.',
	error35: 'Musisz poczekać {0} sekund, żeby postawić ten sam kupon',
	error37: 'Minął termin ważności Freebeta',
	error40: 'Kupon zawiera zdarzenia z niedozwolonych kategorii. Zmodyfikuj go i spróbuj ponownie.',
	error401:
		'Limit łącznych stawek dla konta tymczasowego wynosi 5000 zł. Aby grać dalej, dokonaj pełnej <a href="https://betfan.pl/zaklady-bukmacherskie#section=account-verification">weryfikacji</a> konta.',
	error402: 'Przekroczono maksymalną wygraną dla konta tymczasowego. Zweryfikuj konto by kontynuować grę',
	error43: 'Kupon zawiera zdarzenia, dla których wygrana może wynieść max. {{0}} zł. Zmniejsz stawkę lub zmodyfikuj kupon, aby zagrać.',
	error44: 'Osiągnięto maksymalny limit zakładów na kuponie',
	error45: 'Twój adres IP został zablokowany. Skontaktuj się z Biurem Obsługi Gracza',
	error46: 'Zakład został odrzucony',
	error48: 'Sesja wygasła',
	error5: '{0} nie może być kombinowane z innymi zakładami; {0} nie może być łączone z innymi zakładami',
	error98: '{0} nie może być kombinowane z innymi zakładami; {0} nie może być łączone z innymi zakładami',
	error54: 'Możliwa wygrana jest za niska',
	error55: 'Kurs kuponu musi wynosić min. {{0}}. Zmodyfikuj kupon i spróbuj ponownie.',
	error56: 'Możesz zagrać jeszcze za {{0}} zł lub poczekać na odnowienie dziennego limitu stawek.',
	error56_dailyCustomerLimitReachedToZero: 'Dzienny limit stawek został wykorzystany. Poczekaj na odnowienie limitu lub zmień go.',
	error58: 'Miesięczny limit stawek został wykorzystany. Zwiększ swoje limity',
	error67: 'Niepoprawna stawka',
	error7: 'Zdarzenie jest niedostępne w danym momencie. Spróbuj za chwilę',
	error75: 'Zdarzenia nie mogą być ze sobą kombinowane',
	error8: 'Zdarzenie jest niedostępne w danym momencie. Spróbuj za chwilę.',
	error9: 'Opcja {0} jest niedostępna w danym momencie. Spróbuj za chwilę',
	error95: 'Limit na zdarzenie został przekroczony. Spróbuj ponownie za chwilę lub skontaktuj się z Biurem Obsługi Gracza',
	error1000: 'Kwota zakładu powinna wynosić co najmniej 2 zł',
	error1001: 'Minimalna stawka na kombinacje wynosi 2.00 zł',
	error222: 'Kupon zawiera zdarzenia, dla których wygrana może wynieść max. {{0}} zł. Zmniejsz stawkę lub zmodyfikuj kupon, aby zagrać.',
	error82: 'Właściwe urządzenie do wykorzystania tego bonusu lub freebetu to {{0}}. Zmień urządzenie i spróbuj ponownie.',
	error38: 'Aby wykorzystać bonus lub freebet, musisz zagrać kupon zawierający zdarzenia typu {{0}}. Usuń zdarzenia typu {{1}}.',
	error223: 'Bonus lub freebet nie może być wykorzystany na zakłady z kategorii {{0}}. Zmodyfikuj kupon, aby zagrać.',
	error224: 'Bonus lub freebet nie może być wykorzystany na zakłady z wydarzenia {{0}}. Zmodyfikuj kupon, aby zagrać.',

	// warningMessage
	plnMessage: 'Od wygranych powyżej 2280 zł pobierany jest dodatkowy podatek 10%',
	bonusLessThanThresholdMessage: 'Każda wygrana główna wyższa niż 2280 zł podlega podatkowi w wysokości 10%.',
	bonusMoreThanThresholdMessage: 'Każda wygrana od sprzedaży premiowej wyższa niż 2000 zł podlega podatkowi w wysokości 10%.',
	winningAndBonusMoreThanThresholdMessage:
		'Każda wygrana główna wyższa niż 2280 zł oraz każda wygrana zawierająca AKO Booster o wartości większej niż 2000 zł, podlega podatkowi w wysokości 10%',
	genericTaxMessage:
		'Każda wygrana główna wyższa niż 2280 zł oraz każda wygrana zawierająca AKO Booster o wartości większej niż 2000 zł, podlega podatkowi w wysokości 10%.',
	vipInfoForTax: 'Włączona jest opcja dzielenia kuponów, po postawieniu system rozdzieli kupony w historii kuponów.',

	addToCoupan: 'DODAJ DO KUPONU',
	loginQuickbet: 'ZALOGUJ SIĘ',

	//Todays Filter
	'marketList_gameType_-188': '2. połowa - podwójna szansa',
	'marketList_gameType_-200021': 'Ilość wygranych biegów',
	'marketList_gameType_-200024': 'Pojedynki wirtualne',
	'marketList_gameType_-2527': 'Zwycięzca (z dogrywką)',
	'marketList_gameType_-2962': 'Kto lepszy',
	'marketList_gameType_-2963': 'Zwycięzca (z dogrywką)',
	'marketList_gameType_-30020': 'Zakład specjalny',
	'marketList_gameType_-30022': 'Zwycięzca (3-drogowo)',
	'marketList_gameType_-30023': 'Zakład specjalny',
	'MarketList_gameType_-30023': 'Zakład specjalny',
	'marketList_gameType_-30162': 'Zakład specjalny',
	'marketList_gameType_-309': 'Poniżej/powyżej x punktów (wliczając dodatkowe inningi)',
	'marketList_gameType_-458': 'Handicap',
	'marketList_gameType_-8026': 'Zwycięzca (z super overami)',
	'marketList_gameType_-2967': 'X gol',
	'marketList_gameType_-9002': 'X set - zwycięzca',
	'marketList_gameType_-2560': 'Handicap gemowy X',
	'marketList_gameType_-2970': 'X set - Poniżej/powyżej gemów',
	'marketList_gameType_-2929': 'X set - handicap gemowy',
	'marketList_gameType_-2966': 'Poniżej/powyżej X punktów (z dogrywką)',
	'marketList_gameType_-2950': 'Handicap (z dogrywką)',
	'marketList_gameType_-2948': 'X set - liczba punktów',
	'marketList_gameType_-9004': 'Handicap punktowy',
	'marketList_gameType_-2581': 'Handicap x',
	'marketList_gameType_-8050': 'X mapa - zwycięzca (z dogrywką)',
	'marketList_gameType_-8055': 'Poniżej/powyżej map',
	'marketList_gameType_-8060': 'X mapa - zwycięzca',
	marketList_gameType_1: '1X2',
	marketList_gameType_100: 'Zakład specjalny',
	marketList_gameType_111: '2. połowa - wynik',
	marketList_gameType_120: '1. połowa - obie drużyny strzelą gola',
	marketList_gameType_121: '2. połowa - obie drużyny strzelą gola',
	marketList_gameType_13: 'Poniżej/Powyżej x kartek',
	marketList_gameType_156: 'Handicap -x / +x',
	marketList_gameType_157: 'Handicap +x / -x',
	marketList_gameType_19: 'Poniżej/powyżej x punktów',
	marketList_gameType_190: 'Klasyfikacja',
	marketList_gameType_191: 'Rozrywka',
	marketList_gameType_23: 'Poniżej/powyżej x rzutów rożnych',
	marketList_gameType_27: '1. połowa - podwójna szansa',
	marketList_gameType_29: 'Zwycięzca (z dogrywką i rzutami karnymi)',
	marketList_gameType_3: '1. połowa - wynik',
	marketList_gameType_38: 'Połowa z największą liczbą goli',
	marketList_gameType_4: 'Podwójna szansa',
	marketList_gameType_47: 'Poniżej/Powyżej x gemów',
	marketList_gameType_6: 'Zwycięzca',
	marketList_gameType_8: 'Poniżej/Powyżej x goli',
	marketList_gameType_98: 'Obie drużyny strzelą gola',
	attention: 'Uwaga!',
	warning: 'Ostrzeżenie',
	betBuilderWarning: 'Możesz dodać tylko jednego budowniczego zakładu na wydarzenie',
	betBuilderMaxCouponsLimit: 'Osiągnięto maks. liczbę zdarzeń w BetBuilderze. Jeżeli chcesz dodać nowe zdarzenia, usuń poprzednie.',
	amountWarning: 'Kwota powinna wynosić od 2 do 500000',
	maxBetWarning: 'Osiągnięto maksymalną liczbę zdarzeń na kuponie',
	cpMarketingWarning: `odznaczając zgody marketingowe tracisz możliwość korzystania z promocji. Zastanów się dwa razy, czy warto!`,
	betBuilderExclusiveOddsWarning: 'Wybrane zdarzenia wykluczają się. Proszę wybrać inną kombinację.',
	betBuilderDiffMarketWarning: 'Wybrane rynki nie mogą być łączone',
	betBuilderDialogButtonText: 'Zastąp',
	betBuilderDialogSubtitle: 'W koszyku masz już zdarzenie na ten mecz. Czy chcesz je zastąpić?',
	betBuilderAddEventText: 'Dodaj jeszcze min. 1 zdarzenie, aby utworzyć zakład.',

	// event live
	streamNotFound: 'Nie znaleziono adresu URL strumienia',
	betradarUserNotLoggedIn: 'Proszę się zalogować, aby zobaczyć strumień',
	SISStreamUserNotLoggedIn: 'Proszę się zalogować, aby zobaczyć strumień',
	transmissionInterrupted: 'Trwa przerwa w transmisji',

	betradarUserHasNotPlacedBet: 'Nie stawiałeś zakładu od dnia',
	statscoreErrorMessage: 'Nie udało się załadować widżetu',
	eventNotFound: 'Nie znaleziono zdarzenia',
	eventHasEnded: 'Zdarzenie zakończone!',
	eventIsNoLonger: 'Przepraszamy, ale wybrane zdarzenie nie jest już dostępne.',
	eventTemporaryNoOffer: 'Chwilowo brak oferty.',
	eventWentLiveText: 'Obstawianie zdarzenia zostało zakończone',
	eventWentLiveButton: 'Przejdź do wydarzenia na żywo',
	eventEnd: 'Zakończony',
	eventProgress: 'Trwa',

	// other
	noDataToShow: 'Brak danych do pokazania.',
	noEsportFound: 'Nie znaleziono wydarzeń Esport.',
	noEventFound: 'Nie znaleziono wydarzeń.',
	today: 'Dziś',
	tomorrow: 'Jutro',
	cashoutAvaible: 'Cashout dostępny',
	cashoutDialogInfo: 'Zapewnij sobie wcześniejszą wygraną dzięki opcji Cashout. Rozlicz kupon w dogodnym dla Ciebie momencie i wygraj!',

	// 404 and warning
	break: 'Break!',
	technicalDifficulties: "We're experiencing technical difficulties",
	connectionLost: 'Connection lost.',
	waring404: 'Powrót za {{count}}...',
	checkConnection: 'Sprawdź połączenie z internetem',
	refreshPage: 'ODŚWIEŻ STRONĘ',
	workingOnWebVersion: 'Pracujemy z wersją internetową.',
	useMobileVersion: 'możesz doświadczyć naszej wersji mobilnej. odwiedź wersję mobilną.',
	rotatePhone: 'Obróć swoje urządzenie',
	portraitNotSupportMessage: 'Nie obsługujemy jeszcze trybu poziomego. Aby uzyskać najlepsze wrażenia, wróć do trybu portretowego',
	warning404Title: 'Strona zatonęła!',
	error404Title: 'Błąd',
	appUnavailableInfo: 'Wrócimy za chwilę',

	// PolicyContent title
	cardGamePolicyTitle: 'Legalny polski bukmacher',
	entertainmentPolicyTitle: 'Legalny polski bukmacher',
	eSportPolicyTitle: 'Legalny polski bukmacher',
	homePolicyTitle: 'Zakłady bukmacherskie BETFAN',
	livePolicyTitle: 'Legalny polski bukmacher',
	virtualPolicyTitle: 'Legalny polski bukmacher',
	promotionPolicyTitle: 'Promocje bukmacherskie BETFAN',

	//approve betslip status
	approveBetSlipStatus_0: 'Czekanie na odpowiedź',
	approveBetSlipStatus_1: 'Kupon zaakceptowany',
	approveBetSlipStatus_2: 'Zmiana stawki',
	approveBetSlipStatus_3: 'Kursy się zmieniły',
	approveBetSlipStatus_4: 'Zmieniono stawkę i kursy ',
	approveBetSlipStatus_10: 'Kupon anulowany',

	approveBetStackChange_1: 'Stara stawka:',
	approveBetStackChange_2: 'Nowa stawka:',

	approveBetOddsChange_1: 'Stary kurs:',
	approveBetOddsChange_2: 'Nowy kurs:',

	openInNewWindow: 'Otwórz w oknie',

	offers_OfferConditions_duration: 'Czas zakończenia',
	offers_OfferConditions_maxBonusAmount: 'Maks. bonus',
	offers_OfferConditions_freebetStake: 'Stawka',
	offers_OfferConditions_slipMinStake: 'Min. stawka',
	offers_OfferConditions_slipMaxStake: 'Maks. stawka',
	offers_OfferConditions_combinationMinOdds: 'Min. kurs kuponu',
	offers_OfferConditions_combinationMaxOdds: 'Maks. kurs kuponu',
	offers_OfferConditions_outcomeMinOdds: 'Min. kurs zdarzenia',
	offers_OfferConditions_slipMinNumberOfOutcomes: 'Min. liczba zdarzeń',
	offers_OfferConditions_slipMaxNumberOfOutcomes: 'Maks. liczba zdarzeń',
	offers_OfferConditionsDialog_freebetTitle: 'Zasady wykorzystania freebetu',
	offers_OfferConditionsDialog_bonusTitle: 'Zasady wykorzystania bonusu',
	offers_OfferConditionsDialog_onlySelectedCategories: 'Tylko wybrane kategorie',
	offers_OfferConditionsDialog_atLeastOneInCategory: 'Przynajmniej jeden zakład w kategorii',
	offers_OfferConditionsDialog_inactiveCategory: '{{id}} (nieaktywna)',

	coupon_CouponActionShare_asAnImage: 'Udostępnij jako obraz',
	coupon_CouponActionShare_asALink: 'Udostępnij jako link',
	coupon_CouponActionShare_share: 'Udostępnij',
	coupon_CouponActionShare_saveImage: 'Zapisz jako obraz',
	coupon_CouponActionShare_shareCTA: '',
	coupon_CouponActionShare_shareSuccess: 'Skopiowano link do kuponu',

	couponSimplifiedHeader_won: 'Kupon wygrany',
	couponSimplifiedHeader_placed: 'Kupon w grze',
	couponSimplifiedHeader_lost: 'Kupon przegrany',
	couponSimplifiedHeader_canceled: 'Kupon zwrócony',

	couponBanner_wonText: 'niezła wygrana!',
	couponBanner_bigWonText: 'za hajs betfan baluj!',
	couponBanner_megaWonText: 'kupuj bilet na malediwy!',
	couponBanner_placedText: 'możesz wygrać...',
	couponBanner_lostText: 'jeszcze sie odkujesz',
	couponBanner_cancelledText: 'wraca do ciebie...',

	couponBanner_wonTitle: 'szacun',
	couponBanner_placedTitle: 'trzymamy kciuki',
	couponBanner_lostTitle: 'co za pech',

	//MAP
	mapMap: 'Mapa',
	mapSpotsTitle: 'Mapa punktów BETFAN',
	mapSearchTitle: 'Znajdź punkt na mapie',
	mapSearchPlaceholder: 'np. Warszawa',
	mapLinkLabel: 'Punkty BETFAN',
	mapShowOnMap: 'Pokaż na mapie',
	mapNameAndAddress: 'Nazwa i adres',
	mapBetfanSpotsList: 'Lista Punktów BETFAN',
	mapNavigate: 'Nawiguj do punktu',
	mapWorkingHours: 'Godziny otwarcia:',
	mapSpotsError: 'Pobieranie punktów BETFAN nie powiodło się. Odśwież stronę lub spróbuj ponownie później.',
	monday: 'pon',
	tuesday: 'wt',
	wednesday: 'śr',
	thursday: 'czw',
	friday: 'pt',
	saturday: 'sob',
	sunday: 'nd',

	//units
	day_one: 'dzień',
	day: 'dni',
	hour_one: 'godzina',
	hour_few: 'godziny',
	hour: 'godzin',
	minute_one: 'minuta',
	minute_few: 'minuty',
	minute: 'minut',
	second_one: 'sekunda',
	second_few: 'sekundy',
	second: 'sekund',

	// errors
	nameTooShort: 'Imię za krótkie',

	// betMatch
	betMatch: 'BetMatch',
	removeBetsFromBasketDescription: 'W koszyku masz już przygotowane zakłady. Czy chcesz utworzyć kupon od nowa?',
	replaceEventInBasketDescription: 'W koszyku masz już zdarzenie na ten mecz. Czy chcesz je podmienić?',
	someSwipedBetsTitle: "It's a Bet!",
	noneSwipedBetsTitle: 'Dzisiaj nie trafiła Cię strzała Amora. Sprawdź inne zakłady!',
	expiredBetsTitle: 'Czas minął',
	someSwipedBetsDescription: 'Kupon na dziś jest już gotowy - znajdziesz go w swoim koszyku. Wróć do BetMatcha jutro, aby sprawdzić kolejne karty!',
	expiredBetsDescription: 'Wszystkie spotkania już się rozpoczęły, ale nie martw się - jutro też jest dzień! Czekamy na Ciebie!',
	playAgain: 'Zagraj jeszcze raz',
	fullRemainderDescription: 'Obejrzyj film i dowiedz się, jak z niego korzystać 👇',
	fullRemainderTitle: 'To Twój pierwszy raz z BetMatchem?',
	simpleRemainderDescription: 'Przypominamy 👇',
	simpleRemainderTitle: 'Zapomniałeś, jak działa BetMatch?',
	play: 'Zagraj',
	checkInstructions: 'Zobacz instrukcję',
	eventExpired: 'Zdarzenie nie jest już dostępne',

	//betSlip
	whatToPlayFor: 'Za co chcesz zagrać?',
	availableBalance: 'Dostępny depozyt:',
	activeBonus2: 'Aktywny bonus',
	awaitingBonus: 'Oczekujące bonusy',
	freebetActivated: 'Freebet został aktywowany',
	courseInfoDialogDescription:
		'Edycja ustawień dot. akceptacji zmiany kursu jest dostępna tylko dla zdarzeń LIVE. Dodaj takie zdarzenie do kuponu, aby zmienić ustawienia.',
	depositEmptyMessage: 'W skarbonce pusto. Czas dolać do baku!',
	betslipInfoToast: 'Zaloguj się aby zmienić saldo.',
	betslipInfoModalText: 'Uwaga! Aktywacja nowego bonusu spowoduje wygaśnięcie obecnie aktywnego bonusu. Czy na pewno chcesz aktywować nowy bonus?',
	freebetListTitle: 'Dostępne freebety',
	//Player Profile
	statistics: 'Statystyki',
	notAvailableDialogInfo: 'Profil Gracza dostępny wyłącznie w aplikacji mobilnej.',
	registrationInfo: 'Jesteś z nami już {{totalDays}}',
	medalProfileActiveTab: 'Aktywne',
	medalProfileAvailableTab: 'Dostępne',
	medalProfileCollectedTab: 'Zdobyte',
	medalProfileTitle: 'Medale',
	downloadApp: 'Pobierz apkę',
	selectAvatar: 'Wybierz swój awatar',
	newBadgeText: 'NOWE',
	comingSoon: 'Wkrótce dostępne:',
	yourMedal: 'Twoje Medale',
	playerStatistics: 'Statystki Gracza',
	collectedMedal: 'Odbierz medal',

	//bank payment information
	kontoIntelligo: 'cała doba',
	kontoIntelligo_sat: 'cała doba',
	kontoIntelligo_sun: 'cała doba',
	pkoBP: 'cała doba',
	pkoBP_sat: 'cała doba',
	pkoBP_sun: 'cała doba',
	ingBank: 'cała doba',
	ingBank_sat: 'cała doba',
	ingBank_sun: 'cała doba',
	mBank: 'cała doba',
	mBank_sat: 'cała doba',
	mBank_sun: 'cała doba',
	bankMillenium: '06:00-22:00',
	bankMillenium_sat: '06:00-22:00',
	bankMillenium_sun: 'niedostępny',
	pekaoSA: '06:00-20:00',
	pekaoSA_sat: 'niedostępny',
	pekaoSA_sun: 'niedostępny',
	postalBank: '8:00-18:00',
	postalBank_sat: 'niedostępny',
	postalBank_sun: 'niedostępny',
	bosBank: '09:30-20:00',
	bosBank_sat: '09:30-20:00',
	bosBank_sun: '09:30-20:00',
	nestBank: 'cała doba',
	nestBank_sat: 'cała doba',
	nestBank_sun: 'cała doba',
	ideaBank: 'cała doba',
	ideaBank_sat: 'cała doba',
	ideaBank_sun: 'cała doba',
	bnpParibas: '06:00-20:00',
	bnpParibas_sat: 'niedostępny',
	bnpParibas_sun: 'niedostępny',
	santanderBank: '08:00-21:00',
	santanderBank_sat: 'cała doba',
	santanderBank_sun: 'cała doba',
	volkswagenBank: 'cała doba',
	volkswagenBank_sat: 'cała doba',
	volkswagenBank_sun: 'cała doba',
	toyotaBank: '08:00-21:00',
	toyotaBank_sat: 'niedostępny',
	toyotaBank_sun: 'niedostępny',
	getinNobleBank: 'cała doba',
	getinNobleBank_sat: 'cała doba',
	getinNobleBank_sun: 'cała doba',
	aliorBank: 'cała doba',
	aliorBank_sat: 'cała doba',
	aliorBank_sun: 'cała doba',
	bankWorkingHoursInfo: 'Twój bank  {{bankName}} pracuje w ciągu tych {{bankHours}}',

	//financial overview
	depositButton: 'Wpłać',
	payoutButton: 'Wypłać',
	paymentProcessing: 'Przetwarzamy płatność...',
	paymentProcessingError: 'Wystąpił błąd. Spróbuj ponownie',
	//search animation text
	legiaWarszawa: 'legia warszawa',
	tysonFury: 'tyson fury',
	manchesterUnited: 'manchester united',
	igaSwiatek: 'iga świątek',

	//settings
	settings: 'Ustawienia aplikacji',
	defaultStakes: 'Domyślne stawki',
	defaultStakeDescription: 'Kliknij w stawkę i wpisz nową wartość.',
	lightMode: 'Jasny',
	darkMode: 'Ciemny',
	autoMode: 'Auto',
	settingsSaved: 'Ustawienia zostały zapisane.',
	customStakeInput: 'Domyślna stawka',

	//CP message card
	inbox: 'skrzynka wewnętrzna',
	lastMessage: 'ostatnia wiadomość',
	oneNewMessage: 'nowa wiadomość',
	moreThenOneNewMessage: 'nowych wiadomości',
	upToDate: 'Jesteś na bieżąco',
	marketingText: 'nie czekaj, przeczytaj!',
	marketingTextTwo: 'najnowsza wiadomość',

	//medals
	collectMedal: ' Odbierz medal',
	goToCollected: 'Przejdź do zdobytych',
	goldMedal: 'Złoty medal',
	silverMedal: 'Srebrny medal',
	bronzeMedal: 'Brązowy medal',
	goToOffers: 'Przejdź do oferty',
	medalClaimError: 'Wystąpił błąd podczas odbioru medalu. Spróbuj jeszcze raz.',

	//games
	horseRaceGame: 'Horse race',

	//daily challenge
	dailyChallengePlay: 'Gram dalej',
	dailyChallenge: 'Daily Challenge',
	dailyChallengeModalTitle: 'Jak grać?',
	dailyChallengeUnavailable: 'Daily Challenge jest w tym momencie niedostępny. Spróbuj ponownie później!',
	dailyChallengeLogIn: 'Zaloguj się aby wyświetlić Daily Challenge',
	dailyChallengeModalDescription: 'Dowiedz się, jak w 3 krokach dołączyć do Daily Challenge.',
	dailyModalItem1Title: 'Postaw kupon',
	dailyModalItem1List1: 'Postaw kupon zgodnie z warunkami na karcie',
	dailyModalItem1List2: 'Pamiętaj o liczbie zdarzeń, stawce, min. kursie i kategoriach',

	dailyModalItem2Title: 'Zgarnij freebet',
	dailyModalItem2List1: 'Za wygrany kupon otrzymasz freebet.',
	dailyModalItem2List2: 'Kupon musi zostać rozliczony w czasie trwania promocji',
	dailyModalItem2List3: 'Freebet trafi na konto od razu po zagraniu kuponu spełniającego warunki',

	dailyModalItem3Title: 'Graj za freebet',
	dailyModalItem3List1: 'Freebetem grasz jak chcesz',
	dailyModalItem3List2: 'Brak wymogów dotyczących kursu czy liczby zdarzeń.',
	minCourse: 'Kurs',
	minEvents: 'Liczba zdarzeń',
	minStake: 'Stawka',
	promotionEndsIn: 'Zadanie kończy się za:',
	promotionStartsIn: 'Następne zadanie za:',
	category: 'Kategoria',
	gram: 'Gram',

	goToCardGames: 'Przejdź do gier karcianych',
	expand: 'Rozwiń',
	collapse: 'Zwiń',

	emptyCouponSplashScreen: 'Twoja pierwsza wygrana wciąż na Ciebie czeka!',
	checkOffer: 'Sprawdź ofertę',
	nameYourCoupon: 'Nazwij swój kupon',
	couponName: 'Nazwa kuponu',
	couponInformation: 'Informacje o kuponie',
	couponId: 'ID kuponu',
	copyCouponId: 'Skopiuj ID kuponu',
	copyCouponIdSuccess: 'Skopiowano ID kuponu do schowka',
	close: 'Zamknij',
	max40: 'Maks. liczba znaków to 40. Skróć nazwę kuponu',
	changeCouponNameSuccess: 'Pomyślnie zmieniono nazwę kuponu',
	//player profile
	couponsPlayed: 'Zagranych kuponów',
	biggestWin: 'Największa wygrana',
	biggestOdds: 'Najwyższy kurs kuponu',
	favouriteDiscipline: 'Ulubiona dyscyplina',
	statDialogTitle: 'Jak to działa?',
	statDialogDescription:
		'Twoje statystyki bazują na wszystkich kuponach zagranych od dnia 1 stycznia 2023 roku. Statystyki aktualizowane są co 24 godziny.',
	statDialogButtonText: 'Rozumiem',
	noStatsTitle: 'Jeszcze Cię namierzamy',
	noStatsDescription: 'Aby przedstawić Ci statystyki Twojego konta, potrzebujemy zdobyć o Tobie więcej informacji.',
	noStatsDialogTitle: 'Odblokuj statystyki konta',
	noStatsDialogDescription:
		'Statystyki dostępne są dla graczy, którzy od 1 stycznia 2023 r. zagrali min. 10 kuponów oraz wygrali przynajmniej jeden kupon. Gdy spełnisz te warunki, otrzymasz dostęp do statystyk konta!',
	noMedalTitle: 'Nie ma medali?',
	noMedalSubtitle: 'Sprawdź wszystkie, klikając więcej.',
	noActiveMedalTitle: 'Nie masz aktywnych medali.',
	noActiveMedalSubtitle: 'Obstaw pierwsze kupony i sięgnij po medale.',
	noClaimedMedalTitle: 'Nie masz zdobytych medali.',
	noClaimedMedalSubtitle: 'Obstaw pierwsze kupony i sięgnij po medale.',
	noAvailableMedalTitle: 'Nie masz dostępnych medali.',
	noAvailableMedalSubtitle: 'Obstaw pierwsze kupony i sięgnij po medale.',

	//new payments
	anyAmountFieldValidation: 'Musisz wpisać kwotę',
	enterCardDetails: 'Wpisz dane karty',
	chooseMethod: 'Wybierz metodę płatności',
	chooseBank: 'Wybierz bank',
	changeMethod: 'Zmień metodę',
	blikPayFaster: 'Wpłacaj szybciej BLIKiem',
	blikHowTo: 'Przejdź do aplikacji swojego banku i wygeneruj kod BLIK, a następnie wpisz go poniżej.',
	savePaymentMethod: 'Zapisz metodę do kolejnych płatności',
	pasteFromClipBoard: 'Wklej ze schowka',
	modalPendingBankDescription: 'Potwierdź płatność banku.',
	modalRemoveCardTitle: 'Czy na pewno chcesz usunąć kartę?',
	courses: 'Kursy',
	cardRemovalQuestion: 'Czy na pewno chcesz usunąć kartę?',
	payWithBlikTitle: 'Wpłata BLIK',
	goToEnterBlik: 'Przejdź do wpisania kodu',
	blikCodeLabel: 'Kod BLIK',
	cardRemoveQuestion: 'Czy na pewno chcesz usunąć kartę?',
	popularPayment: 'Popularna',
	cardAddedSuccessFully: 'Pomyślnie dodano kartę.',
	addCard: 'Dodaj kartę',

	outcome1x2Title: 'Zwycięzca meczu (reg. czas gry)',
	refreshingOdds: 'Odświeżamy kursy na lepsze',
	refreshingOddsShort: 'Odświeżamy kursy',
	tv: 'TV',

	//pickem
	loginToPlay: 'Zaloguj się, aby zagrać',

	reload: 'Odśwież stronę',
	tryAgain: 'Spróbuj ponownie',
	startPlay: 'Gram!',
	categories: 'Kategorie',

	//special
	checkWhatWeHaveForYou: 'Sprawdź, co dla Ciebie mamy! 🔥',

	//fast payment
	depositOnClick: 'Wpłać {{amount}} zł jednym klinięciem',
	depositWith: 'Zapłać z',

	validationErrors: 'Popraw formularz',

	registrationMethods_mojeId_fastest: 'Najszybciej',
	registrationMethods_mojeId_header: 'Konto bezterminowe',
	registrationMethods_mojeId_subtitle: 'Szybka i bezpieczna rejestracja przez:',
	registrationMethods_mojeId_accountVerified: 'Konto zweryfikowane - możliwość wypłaty wygranej od razu',
	registrationMethods_mojeId_button: 'Załóż konto przez swój bank',
	registrationMethods_mojeId_expanded_button: 'Kontynuuj zakładanie konta',

	registrationMethods_mojeId_expanded_subheader: 'Zanim rozpoczniesz, upewnij się, że:',
	registrationMethods_mojeId_expanded_subtitle: 'Twoje konto znajduje się w jednym z poniższych banków:',
	registrationMethods_mojeId_expanded_login: 'Pamiętasz swój login oraz hasło do logowania się w banku.',
	registrationMethods_mojeId_expanded_security: 'Przechodząc przez ten proces logujesz się bezpośrednio do swojego banku.',
	registrationMethods_mojeId_expanded_security_bold: 'Twoje dane są bezpiecznie i nieudostępniane nikomu.',

	registrationMethods_manual_header: 'Konto na 30 dni',
	registrationMethods_manual_subtitle: 'Konto niezweryfikowane - konieczna ręczna weryfikacja w ciągu 30 dni',
	registrationMethods_manual_button: 'Przejdź do formularza',
	registrationMethods_or: 'lub',

	registrationMethods_welcome: 'Witaj w BETFAN!',
	registrationMethods_new: 'NOWOŚĆ',
	registrationMethods_mojeId: 'mojeID',
	registrationMethods_form: 'Formularz rejestracyjny',

	registrationMethods_openFullAccount: 'Załóż konto pełne',
	registrationMethods_registrationWithoutDocuments: 'Rejestracja bez wysyłania dokumentów.',
	registrationMethods_openTemporaryAccount: 'Załóż konto tymczasowe',
	registrationMethods_verificationNeeded: 'Konieczna weryfikacja w ciągu 30 dni.',

	verificationMethods_mojeId_fastest: 'Najszybciej',
	verificationMethods_mojeId_header: 'Weryfikacja przez bank',
	verificationMethods_mojeId_subtitle: 'Szybka i bezpieczna weryfikacja przez:',
	verificationMethods_mojeId_noDocument: 'Weryfikacja bez wysyłania dokumentów.',
	verificationMethods_mojeId_button: 'Zweryfikuj się przez bank',

	verificationMethods_mojeId_expanded_subheader: 'Zanim rozpoczniesz, upewnij się, że:',
	verificationMethods_mojeId_expanded_subtitle: 'Twoje konto znajduje się w jednym z poniższych banków:',
	verificationMethods_mojeId_expanded_login: 'Pamiętasz swój login oraz hasło do logowania się w banku.',
	verificationMethods_mojeId_expanded_accountNumber: 'Masz pod ręką swój numer konta oraz adres miejsca zamieszkania. ',
	verificationMethods_mojeId_expanded_accountNumber_bold: 'Możesz zostać poproszony o ich podanie.',
	verificationMethods_mojeId_expanded_security: 'Przechodząc przez ten proces logujesz się bezpośrednio do swojego banku.',
	verificationMethods_mojeId_expanded_security_bold: 'Twoje dane są bezpiecznie i nieudostępniane nikomu.',
	verificationMethods_mojeId_expanded_button: 'Kontynuuj weryfikację konta',

	verificationMethods_manual_header: 'Weryfikacja przez formularz',
	verificationMethods_manual_prepareDocs: 'Przygotuj jeden z dokumentów: dowód osobisty, paszport lub karta pobytu. ',
	verificationMethods_manual_prepareDocs_bold: 'Podczas procesu potrzebne nam będzie  zdjęcie Twojego dokumentu.',
	verificationMethods_manual_prepareAccountNum: 'Przygotuj swój numer konta bankowego.',
	verificationMethods_manual_placeOfResidence: 'Zostaniesz poproszony o podanie miejsca zamieszkania.',
	verificationMethods_manual_button: 'Przejdź do formularza',

	verificationMethods_bank_title: 'Zweryfikuj się przez bank',
	verificationMethods_bank_subtitle: 'Weryfikacja bez wysyłania dokumentów.',
	verificationMethods_new: 'NOWOŚĆ',
	verificationMethods_mojeId: 'mojeID',
	verificationMethods_form_title: 'Zweryfikuj się przez formularz',
	verificationMethods_form_subtitle: 'Konieczne przesłanie dokumentów.',
	verificationMethods_form: 'Formularz weryfikacyjny',

	mojeId_waitingForData: 'Czekamy na Twoje dane z mojeID.',
	mojeId_doNotLeaveThePage: 'Nie wychodź ze strony.',
	mojeId_justAMoment: 'Jeszcze chwilę…',
	mojeId_takingABitLonger: 'Zajmuje to nieco dłużej niż zwykle.',

	mojeId_nextStep: 'Przejdź dalej',
	mojeId_previousStep: 'Wstecz',
	mojeId_finishRegistration: 'Zakończ rejestrację',
	mojeId_finishVerification: 'Zakończ weryfikację',

	mojeId_authData_title: 'Wpisz e-mail i hasło do konta',
	mojeId_authData_passwordRules:
		'Hasło musi składać się z min. 8 znaków, posiadać wielką literę oraz min. 1 cyfrę. Nie może zawierać polskich liter np. ą, ę, ś i znaków specjalnych ` ~ ( ) > \' " \\',

	mojeId_phoneNumber_title: 'Wpisz numer telefonu',
	mojeId_phoneNumber_label: 'Numer telefonu',
	mojeId_phoneNumber_invalid: 'Numer telefonu jest nieprawidłowy',

	mojeId_smsCode_sendingFailed: 'Nie mogliśmy wysłać kodu SMS',
	mojeId_smsCode_title: 'Wpisz kod SMS',
	mojeId_smsCode_label: 'Kod SMS',
	mojeId_smsCode_resend: 'WYŚLIJ PONOWNIE KOD',
	mojeId_smsCode_sent: 'Kod SMS wysłany',
	mojeId_smsCode_invalid: 'Nieprawidłowy kod SMS',

	mojeId_accountNumber_title: 'Wpisz numer konta bankowego',
	mojeId_accountNumber_label: 'Numer konta bankowego',

	mojeId_countryOfBirth_title: 'Wybierz kraj urodzenia',
	mojeId_countryOfBirth_label: 'Kraj urodzenia',

	mojeId_addressCity_title: 'Uzupełnij miejsce zamieszkania',
	mojeId_addressCity_city: 'Miasto',
	mojeId_addressCity_postalCode: 'Kod pocztowy',

	mojeId_addressStreet_title: 'Uzupełnij miejsce zamieszkania',
	mojeId_addressStreet_street: 'Ulica',
	mojeId_addressStreet_buildingNumber: 'Nr budynku',
	mojeId_addressStreet_apartmentNumber: 'Nr mieszkania',

	mojeId_statements_title: 'Zgody, czyli to już prawie koniec',
	mojeId_statements_pepStatement: 'Oświadczenie PEP',
	mojeId_statements_pepNo: 'Nie jestem PEP',
	mojeId_statements_pepYes: 'Jestem PEP',
	mojeId_statements_pep_description_title: 'Informacje PEP',
	mojeId_statements_pep_description_body:
		'Oświadczam, że nie jestem/byłem osobą zajmującą EKSPONOWANE STANOWISKO POLITYCZNE oraz nie jestem członkiem rodziny ani bliskim współpracownikiem takiej osoby PEP. Czym jest PEP? Politically Exposed Persons to osoby fizyczne zajmujące eksponowane stanowiska polityczne lub pełniące znaczące funkcje publiczne.',

	mojeId_statements_chooseFundSource: 'Wybierz źródło środków na grę',
	mojeId_statements_chooseFundSource_optionModalTitle: 'Wybierz źródło środków',
	mojeId_statements_fundSourceIsRequired: 'Źródło środków na grę jest wymagane',
	mojeId_statements_otherFundSource: 'Jakie?',
	mojeId_statements_otherFundSourceIsRequired: 'Podaj źródło środków na grę',

	mojeId_statements_ageConsent:
		'Zapoznałem się i akceptuję Regulamin Internetowych Zakładów Wzajemnych BETFAN, Regulamin Odpowiedzialnej Gry BETFAN, jak i poniższe oświadczenia.',
	mojeId_statements_ageConsentIsRequired: 'To oświadczenie jest wymagane',

	mojeId_promoCode_title: 'Wpisz kod i czekaj na prezent',
	mojeId_promoCode_label: 'Kod promocyjny',
	mojeId_promoCode_scratchYourCode: 'ZDRAP SWÓJ KOD',

	mojeId_email: 'Adres e-mail',
	mojeId_repeatPassword: 'Powtórz hasło',
	mojeId_userAlreadyExists: 'Hej! Masz już u nas konto',
	mojeId_loginOrResetPassword: 'Zaloguj się lub kliknij “Zapomniałeś hasła?”, jeśli faktycznie zapomniałeś.',
	mojeId_problemsWithSigningIn: 'Masz problemy z logowaniem?',
	mojeId_contactSupport: 'Skontaktuj się z obsługą',
	mojeId_success: 'Gratulacje! To koniec formalności! Wchodź do gry i wygrywaj!',
	mojeId_success_notVerified: 'Gratulacje! Zarejestrowałeś konto. Pamiętaj, by się zweryfikować.',

	mojeId_registrationFailed: 'Rejestracja nie powiodła się.',
	mojeId_cannotRegisterWithMojeId: 'Nie możesz zarejestrować się przez mojeID.',
	mojeId_useRegistrationForm: 'Użyj standardowego formularza',
	mojeId_problemsWithRegistration: 'Masz problemy z rejestracją?',

	mojeId_verificationFailed: 'Weryfikacja nie powiodła się.',
	mojeId_cannotVerifyWithMojeId: 'Nie możesz zweryfikować się przez mojeID.',
	mojeId_useVerificationForm: 'Użyj standardowego formularza',
	mojeId_problemsWithVerification: 'Masz problemy z weryfikacją?',

	mojeId_verification_wrongUser_title: 'Zmień konto, aby kontynuować proces weryfikacji.',
	mojeId_verification_wrongUser_subtitle: 'Wygląda na to, że wcześniej już rozpocząłeś proces weryfikacji na innym koncie.',
	mojeId_verification_wrongUser_switchAccounts: 'Zmień konto',
	mojeId_verification_wrongUser_abort: 'Przerwij proces',

	quickShot_ratingBar_thankYou: 'Dziękujemy za Twoją opinię!',
	quickShot_ratingBar_chooseRating: 'Jak oceniasz te zakłady?',
	quickShot_ratingBar_bad: 'Słabo',
	quickShot_ratingBar_good: 'Spoko',
	quickShot_ratingBar_super: 'Super!',

	main_balance_empty: 'W skarbonce pusto.',
	time_to_top_up: 'Czas dolać do baku!',
	deposit_balance_below_two: 'Minimalna stawka zakładu to 2 zł.',
	accessible_amount: 'Dostępne środki',

	topUpMessage1: 'W skarbonce prawie pusto.',
	topUpMessage2: 'Czas dolać do baku!',

	notificationTitle: 'Nie przegap żadnego bonusu!',
	notificationSwitch: 'Włącz powiadomienia',

	installPwaButton: 'Zainstaluj',
	installPwaClose: 'Rozumiem',
	installPwaInfo: 'Gdybyś zmienił zdanie, zawsze możesz zainstalować appkę z panelu bocznego.',
	installPwaError: 'Nie udało się zainstalować aplikacji. Spróbuj ponownie lub skontaktuj się z nami',

	hasInstalledPwa: 'Aplikacja jest już zainstalowana',

	backgroundLoginAdditionalText: 'Czas wklepać wygraną! Pudzian na KSW już dziś!',
	backgroundLoginText: 'Logujemy Cię...',

	// PUDZIAN AI HORSE
	ai: 'AI',
	aiBannerAlt: 'AI VS. INTUICJA Z KIM UGOTUJESZ SWÓJ PIERWSZY KUPON?',
	aiPudzianAlt: 'Głowa Pudziana w kucharskim kapeluszu',
	aiHorseAlt: 'Cybernetyczna głowa Konia Betfan',
	intuition: 'Intuicja',
	aiDetection: 'Wykryto mało zasobów w portfelu.',
	aiSuggestion: 'Sugerowane jest uzupełnienie środków.',
	aiWelcomeOfferText: 'Wybierając 200zł otrzymasz najbardziej opłacalną ofertę.',
	aiLuckyNumberText: '200 to moja szczęśliwa liczba!',

	//promo conditions

	promoConditions_duration: 'Czas zakończenia',
	promoConditions_maxBonusAmount: 'Maks. bonus',
	promoConditions_freebetStake: 'Stawka',
	promoConditions_slipMinStake: 'Min. stawka',
	promoConditions_slipMaxStake: 'Maks. stawka',
	promoConditions_combinationMinOdds: 'Min. kurs kuponu',
	promoConditions_combinationMaxOdds: 'Maks. kurs kuponu',
	promoConditions_outcomeMinOdds: 'Min. kurs zdarzenia',
	promoConditions_slipMinNumberOfOutcomes: 'Min. liczba zdarzeń',
	promoConditions_slipMaxNumberOfOutcomes: 'Maks. liczba zdarzeń',
	promoConditions_freebetTitle: 'Zasady wykorzystania freebetu',
	promoConditions_bonusTitle: 'Zasady wykorzystania bonusu',
	promoConditions_onlySelectedCategories: 'Tylko wybrane kategorie',
	promoConditions_atLeastOneInCategory: 'Przynajmniej jeden zakład w kategorii',
	promoConditions_inactiveCategory: '{{id}} (nieaktywna)',
	promoConditions_doesNotApply: 'Nie dotyczy',
	promoConditions_onlyOutOf: 'Kategoria tylko z',
	promoConditions_oneOutOf: 'Kategoria jedna z',
	promoConditions_couponOdds: 'Kurs kuponu',
	promoConditions_eventOdds: 'Kurs zdarzenia',
	promoConditions_minimum: 'minimum',
	promoConditions_maximum: 'Max',
	promoConditions_anyCategory: 'Dowolna',
	promoConditions_timeConditions: 'Warunek czasowy',
	promoConditions_eventsStartBefore: 'wydarzenia rozpoczynają się najpóźniej',
	promoConditions_validTo: 'Ważny do',
	promoConditions_event: 'Wydarzenie',
	promoConditions_only: 'Tylko',
	promoConditions_betType: 'Rodzaj zakładu',
	promoConditions_betTypeOneOutOf: 'Rodzaj zakładu jeden z',
	promoConditions_eventTypeOneOutOf: 'Status zdarzenia jeden z',
	promoConditions_eventStatus: 'Status zdarzenia',
	promoConditions_eventStatusAllIn: 'Status zdarzenia tylko z',
	promoConditions_coupon: 'Kupon',

	placeCouponsForDeposit: 'Postaw kupony za depozyt',
	wagerDepositFunds: 'Obróć środkami na depozycie',
	minimumCouponOdds: 'kurs kuponu minimum',

	rewardCardAvailable: 'Dostępny',
	rewardCardActive: 'Aktywny',
	rewardCardInactive: 'Nieaktywny',
	rewardCardUnlocked: 'Odblokowany',
	rewardCardLocked: 'Zablokowany',
	rewardCardUse: 'Użyj',
	rewardCardModalTitle: 'Jak odblokować ten bonus?',
	rewardCardLeftToWager: 'Pozostały obrót do wypłaty:',
	rewardCardModalDescriptionDeposit: 'Aby móc zagrać za ten bonus musisz najpierw obrócić środkami na swoim koncie depozytowym.',
	rewardCardModalDescriptionCoupon: 'Aby móc zagrać za ten bonus musisz postawić kupony za środki ze swojego konta depozytowego.',
	rewardCardModalDescriptionBoth: 'BOTH Aby móc zagrać za ten bonus musisz postawić kupony za środki ze swojego konta depozytowego.',
	rewardCardModalActual: 'Aktualny postęp masz zawsze widoczny na kafelku z bonusem:',
	rewardCardModalDynamicDeposit:
		'Do tej pory obróciłeś <span>{{unlockedSum}}zł</span> z wymaganych <span>{{totalSumToUnlock}}zł</span> z konta depozytowego',

	rewardCardModalDynamicCoupon: 'Do tej pory postawiłeś <span>{{unlockedBets}}</span> z <span>{{totalBetsToUnlock}}</span> wymaganych kuponów',
	rewardCardProgressBets: '{{unlockedBets}} z {{totalBetsToUnlock}} kuponów',
	rewardCardProgressAmount: '{{unlockedSum}} z {{totalSumToUnlock}} zł',
	rewardCardAvailableFunds: '<span>{{availableSum}} zł</span> (z {{totalSum}} zł)',
	rewardCardModalDynamicOdds: ' o <span>kursie minimum {{odds}}</span>',
	rewardCardModalDynamicOddsAko: 'kuponem lub kuponami AKO o <span>kursie minimum {{odds}}</span>',
	rewardCardModalDynamicOddsCoupon: ' kuponem lub kuponami <span>{{type}}</span>',
	rewardCardModalCoupon: ' kuponem lub kuponami',

	regPromotionPickerAvailable: 'Dostępne promocje:',
	regPromotionPickerChosen: 'Aktywna promocja:',
	regPromotionPickerInputUse: 'UŻYJ',
	regPromotionPickerToastSuccess: 'Użyto kod promocyjny',
	regPromotionPickerToastError: 'Promocja nie istnieje',
	regPromotionPickerPromotionAvailableTo: 'promocja ważna do: ',
	regPromotionPickerPromotionAvailable: 'promocja ważna do odwołania',
	regPromotionPickerPromotionFetchError: 'Błąd podczas ładowania promocji. Spróuj ponownie',
};

export default pl;
